<template>
    <div class="advanced-search-wrapper">
        <div>
            <div class="selected-filters-wrapper" :class="{'apply-config-mode-styles':enableConfigMode}">
                <template v-if="!enableConfigMode">
                    <div v-for="filter in combinedFilters" :key="filter.key"  v-click-outside="removeSelectedClass" class="selected-filter">
                        <template v-if="filter.type == 'PICKLIST_MULTIVALUE'">
                            <div v-if="filter.key == 'tag_id'" :id="filter.key" class="filter-wrapper" :class="{focusTheField:autoFocusedField == filter.key, 'apply-background':updatedTagsList && updatedTagsList.length}">
                                <div class="filter-label">{{$t(filter.name)}} :</div>
                                <tags-dropdown :ref="filter.key" :selectedTagIds="updatedTagsList" :componentUUID="filter.key" @updatedBulkTagsList="bulkTagsFindCollectionOnSelect" @updatedTagsList="tagsFindCollectionOnSelect" @removedTagsFromList="tagsFindCollectionOnRemove" from="Advanced Search"></tags-dropdown>
                                <!-- <remove-field class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field> -->
                            </div>
                            <div v-else-if="filter.key == 'catalog_id'" :id="filter.key" class="filter-wrapper" :class="{focusTheField:autoFocusedField == filter.key, 'apply-background':updatedFilteredCatalogsList && updatedFilteredCatalogsList.length}">
                                <div class="filter-label">{{$t(filter.name)}} :</div>
                                <CatalogDropdown 
                                :ref="filter.key" 
                                :componentUUID="filter.key" 
                                :enableCatBrowser="false"
                                :selectedCatalogIds="updatedFilteredCatalogsList"
                                from="Advanced Search"
                                @removedCatalogFromList="removedCatalogFromList"
                                @updatedCatalogsList="updatedCatalogsListComp" class="catalog-filter"></CatalogDropdown>
                                <!-- <remove-field class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field> -->
                            </div>
                            <div v-else-if="filter.key == 'label_id'" :id="filter.key" class="filter-wrapper" :class="{focusTheField:autoFocusedField == filter.key, 'apply-background':updatedLabelsList && updatedLabelsList.length}">
                                <div class="filter-label">{{$t(filter.name)}} :</div>
                                <labelsMultiselect :ref="filter.key" :componentUUID="filter.key" 
                                from="Advanced Search" :selectedLabelsId="updatedLabelsList"
                                @updatedLabelsList="labelsFindCollectionOnSelect" @removedLabelsFromList="labelsFindCollectionOnRemove" class="catalog-filter"></labelsMultiselect>
                                <!-- <remove-field class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field> -->
                            </div>
                            <div v-else class="filter-wrapper" :id="filter.key" :class="{focusTheField:autoFocusedField == filter.key, 'apply-background':multiPicklistMapper[filter.key] && multiPicklistMapper[filter.key].length}">
                                <div class="filter-label">{{$t(filter.name)}} :</div>
                                <Multiselect
                                    v-model="multiPicklistMapper[filter.key]"
                                    :options="filter.values"
                                    :ref="filter.key"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :show-no-results="false"
                                    track-by="value_id"
                                    label="value"
                                    deselectLabel=""
                                    selectLabel=""
                                    selectedLabel=""
                                    :placeholder="customisePlaceholder(filter.name,'Select')"
                                    :hideSelected="false"
                                    :showNoOptions="false"
                                    class="multi-tags-select"
                                    @select="multiPicklistValueTypeOnSelect($event, filter.key,filter.filter_type)"
                                    @remove="multiPicklistValueTypeOnRemove($event, filter.key,filter.filter_type)"
                                    :searchable="true">
                                    <div slot="tag" slot-scope="option" class="selected-tags-style">
                                        <div class="tags-display-style">{{option.option.value}}</div>
                                            <div class="remove-tag" v-on:click="multiPicklistValueTypeOnRemove(option.option,filter.key,filter.filter_type)">
                                                <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                                </svg>
                                            </div>
                                        </div>
                                        <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                        <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makePicklistCheckBoxSelection(scope.option,filter.key)" @focus.prevent :key="scope.option.value_id"/>
                                        <span style="margin-inline-start:12px;">{{ scope.option.value }}</span>
                                    </div>
                                </Multiselect>
                                <!-- <remove-field class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field> -->
                            </div>
                        </template>
                        <div v-if="filter != undefined && (filter.type == 'FREETEXT' || filter.type == 'FREETEXT_MULTILINE')" :id="filter.key" class="filter-wrapper" :class="{'apply-background':checkIfValueAvailable(filter.key)}">
                            
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <input
                                type="text"
                                :ref="filter.key"
                                style="position:relative;top:0px;"
                                class="rounded text-light comm-input-field-style"
                                :placeholder="customisePlaceholder(filter.name,'Enter')"
                                :value="filter.filter_type == 'field' &&  completeFormData['fields'] && completeFormData['fields'][filter.key]? completeFormData['fields'][filter.key] : completeFormData[filter.key] ? completeFormData[filter.key] : ''"
                                @input="filter.filter_type == 'field' ? 
                                    $event.target.value.length ? 
                                        completeFormData['fields'][filter.key] = $event.target.value : delete  completeFormData['fields'][filter.key] : 
                                    $event.target.value.length == 0 ?
                                        delete completeFormData[filter.key] : completeFormData[filter.key] = $event.target.value"
                                autocomplete="off"
                                @keyup.enter="formData(),applyBackgroundForInputTextField[filter.key] && applyBackgroundForInputTextField[filter.key].length != 0?applyBackgroundForInputTextField[filter.key] = true:applyBackgroundForInputTextField[filter.key] = false"
                            />
                            <remove-field class="remove-field-styles" v-if="checkIfValueAvailable(filter.key)" @click.native="removeSelectedFilter(filter)" style="height: 30px;color: #a9a9a9;"></remove-field>
                        </div>
                        <div v-if="filter != undefined && filter.type == 'DATE'" :id="filter.key" class="filter-wrapper" :class="{'apply-background':dateMappper[filter.key] && dateMappper[filter.key].length}">
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <date-picker
                                        range
                                        v-model="dateMappper[filter.key]"
                                        @input="updateDateValue(filter.filter_type,dateMappper[filter.key],filter.key, filter.type)"
                                        :ref="filter.key"
                                        :clearable="false"
                                        valueType="format"
                                        :placeholder="customisePlaceholder(filter.name,'Enter')"
                                        class="text-light comm-input-field-style"
                                        style="padding: 0px;border-radius: 5px;position:relative;top:0px"
                                        @close="dateMappper[filter.key] && dateMappper[filter.key].length > 0?formData():''"
                            ></date-picker>
                            <remove-field class="remove-field-styles" v-if="dateMappper[filter.key] && dateMappper[filter.key].length" @click.native="removeSelectedFilter(filter)" style="height: 30px;color: #a9a9a9;"></remove-field>
                        </div> 
                        <div v-if="filter != undefined && filter.type == 'DATE_TIME'" :id="filter.key" class="filter-wrapper" :class="{'apply-background':dateMappper[filter.key] && dateMappper[filter.key].length}">
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <date-picker
                                        range
                                        v-model="dateMappper[filter.key]"
                                        @input="updateDateValue(filter.filter_type,dateMappper[filter.key],filter.key, filter.type)"
                                        :ref="filter.key"
                                        :clearable="false"
                                        type="datetime"
                                        valueType="format"
                                        :placeholder="customisePlaceholder(filter.name,'Enter')"
                                        class="text-light comm-input-field-style"
                                        style="padding: 0px;border-radius: 5px;position:relative;top:0px"
                                        @close="dateMappper[filter.key] && dateMappper[filter.key].length > 0?formData():''"
                                        confirm
                            ></date-picker>
                            <remove-field class="remove-field-styles" v-if="dateMappper[filter.key] && dateMappper[filter.key].length" @click.native="removeSelectedFilter(filter)" style="height: 30px;color: #a9a9a9;"></remove-field>
                        </div> 
                        <div v-if="filter != undefined && filter.type == 'INTEGER'" :id="filter.key" class="filter-wrapper" :class="{'apply-background':integerMapper[filter.key] && integerMapper[filter.key].toString() && integerMapper[filter.key].toString().length > 0}">
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <input
                                type="text"
                                :ref="filter.key"
                                style="position:relative;top:0px"
                                class="rounded text-light comm-input-field-style"
                                :placeholder="customisePlaceholder(filter.name,'Enter')"
                                v-model="integerMapper[filter.key]"
                                @input="customiseIntegerPostDataBasedOnType(filter.filter_type,$event.target.value,filter.key)"
                                autocomplete="off"
                                @keypress="acceptOnlyNumbers($event)"
                                @keyup.enter="formData()"
                            />
                            <remove-field class="remove-field-styles" v-if="integerMapper[filter.key] && integerMapper[filter.key].toString() && integerMapper[filter.key].toString().length > 0" @click.native="removeSelectedFilter(filter)" style="height: 30px;color: #a9a9a9;"></remove-field>
                        </div>
                        <div v-if="filter != undefined && filter.type == 'users'" :id="filter.key" class="filter-wrapper" :class="{'apply-background':usersFilterMapper[filter.key] && usersFilterMapper[filter.key].length > 0}">
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <users-multiselect :ref="filter.key" :componentUuid="filter.key" :selectedUserIdList="usersFilterMapper[filter.key]" :enableCheckbox="true" :isSearchable="true" @updatedUsersList='updatedUsersList' @removedUserFromList='removedUserFromList'></users-multiselect>
                            <remove-field class="remove-field-styles" v-if="usersFilterMapper[filter.key] && usersFilterMapper[filter.key].length > 0" @click.native="removeSelectedFilter(filter)" style="height: 30px;width: 50px;color: #a9a9a9;"></remove-field>
                        </div>
                        <div v-if="filter != undefined && filter.type == 'PICKLIST' && filter.key == 'created_on'" :id="filter.key" class="filter-wrapper" :class="{'apply-background':selectedCreatedDateValue && Object.keys(selectedCreatedDateValue).length}">
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <date-picker
                                    v-if="['after_date','before_date','on_date'].includes(selectedCreatedDateValue.value_id)"
                                    :range="false"
                                    v-model="createdDateCustomFilterValSingleVal"
                                    @input="updatePrimayCreatedOnSingleSelectFilterValue('created_on',createdDateCustomFilterValSingleVal,selectedCreatedDateValue.value_id)"
                                    :clearable="false"
                                    valueType="format"
                                    ref="createdOnSingle"
                                    placeholder=''
                                    class="text-light comm-input-field-style"
                                    style="padding: 0px;border-radius: 5px;position:relative;top:0px;width:170px"
                                    >
                                    <template slot="input" slot-scope="{ picker }">
                                    {{selectedCreatedDateValue.value}} {{createdDateCustomFilterValSingleVal}} {{ picker }}
                                    </template>
                            </date-picker>
                            <date-picker
                                    v-click-outside='hidePicker'
                                    v-else-if="selectedCreatedDateValue.value_id == 'year_range'"
                                    range
                                    v-model="createdDateCustomFilterValForYearRange"
                                    @input="updatePrimayCreatedOnFilterValue('created_on',createdDateCustomFilterValForYearRange,selectedCreatedDateValue.value_id,'year')"
                                    :clearable="false"
                                    valueType="format"
                                    ref="createdOnYearRange"
                                    placeholder=''
                                    type="year"
                                    format="YYYY"
                                    :max-year="getCurrentYear()"
                                    class="text-light comm-input-field-style"
                                    style="padding: 0px;border-radius: 5px;position:relative;top:0px;width:210px"
                                    @clear="selectedCreatedDateValue = {}"
                            ></date-picker>
                            <date-picker
                                v-click-outside='hidePicker'
                                v-else-if="selectedCreatedDateValue.value_id == 'range'"
                                range
                                v-model="createdDateCustomFilterVal"
                                @input="updatePrimayCreatedOnFilterValue('created_on',createdDateCustomFilterVal,selectedCreatedDateValue.value_id)"
                                :clearable="false"
                                valueType="format"
                                ref="createdOnRange"
                                placeholder=''
                                class="text-light comm-input-field-style"
                                style="padding: 0px;border-radius: 5px;position:relative;top:0px;width:210px"
                                @clear="selectedCreatedDateValue = {}"
                            ></date-picker>
                            <Multiselect
                                v-else
                                v-model="selectedCreatedDateValue"
                                :options="filter.values"
                                placeholder=""
                                :searchable="true"
                                :close-on-select="true"
                                :allow-empty="false"
                                track-by="value_id"
                                label="value"
                                deselectLabel=""
                                selectLabel=""
                                selectedLabel=""
                                @select="updateCreatedOnFilter('created_on',$event)"
                                style="margin-top: 7px;">
                                <div slot="singleLabel" slot-scope="{ option }">
                                    {{ option.value }}
                                </div>
                                <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                    <span style="margin-inline-start:12px;">{{ scope.option.value}}</span>
                                </div>
                                <span slot="noResult">No results.</span>
                            </Multiselect>
                            <remove-field class="remove-field-styles" v-if="Object.keys(selectedCreatedDateValue).length" @click.native="selectedCreatedDateValue = {}, createdDateCustomFilterValSingleVal = null, createdDateCustomFilterVal = null,createdDateCustomFilterValForYearRange = null, delete completeFormData['created_on'], formData()" style="height: 30px;color: #a9a9a9" :style="['after_date','before_date','on_date','range','year_range'].includes(selectedCreatedDateValue.value_id)?'width:30px':'width:60px'"></remove-field>
                        </div>
                        <div v-else-if="filter != undefined && filter.type == 'PICKLIST' && filter.key == 'duration'" class="filter-wrapper comm-custom-range-fields" :class="{'apply-background':appliedLabel && appliedLabel.length}">
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <div class="dropdown" v-click-outside="closeDurationDropdown">
                                <div
                                    class="dropdown-header"
                                    :class="{ active: appliedLabel }"
                                    @click.stop="toggleDropdown('duration')"
                                >
                                <span :style="appliedLabel?'color:#fff':'color:#5d5d5d'">
                                    {{ appliedLabel || $t('Select duration') }}
                                </span>

                                <div style="display:flex;align-items:center;gap:10px;margin-inline-start: 8px;position: relative;top: 1px;">
                                    <i v-if="!open" class="bi bi-caret-down-fill" style="font-size: 11px;color: #999;"></i>
                                    <i v-if="open" class="bi bi-caret-up-fill" style="font-size: 11px;color: #999;"></i>
                                </div>
                                </div>

                                <div v-if="open" class="dropdown-list">
                                
                                    <template v-for="opt in filter.values">    
                                        <div
                                            v-if="opt.value != 'Custom duration range'"
                                            :key="opt.value_id"
                                            class="option"
                                            @click.stop="selectDurationOption(opt)"
                                        >
                                            {{ opt.value }}
                                        </div>
                                    </template>    

                                    <div class="custom-row" @click.stop="openCustom('duration')">
                                        {{$t('Custom duration range')}}
                                    </div>

                                    <div v-if="customOpen" @mousedown.stop @click.stop>

                                        <div class="inputs">
                                        <input v-model="min" type="number" :placeholder="$t('From')">
                                        <input v-model="max" type="number" :placeholder="$t('To')">

                                        <select v-model="unit">
                                            <option value="Sec">{{$t('Sec')}}</option>
                                            <option value="Min">{{$t('Min')}}</option>
                                            <option value="Hr">{{$t('Hr')}}</option>
                                        </select>
                                        </div>

                                        <div class="actions">
                                            <button class="btn cancel" @click="cancel('duration')">{{$t('Cancel')}}</button>
                                            <button class="btn apply" @click="apply">{{$t('Apply')}}</button>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <remove-field v-if="appliedLabel" class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                        </div>
                        <div v-else-if="filter != undefined && filter.type == 'PICKLIST' && filter.key == 'size'" class="filter-wrapper comm-custom-range-fields" :class="{'apply-background':appliedSizeLabel && appliedSizeLabel.length}">
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <div class="dropdown"  v-click-outside="closeSizeDropdown">
                                <div
                                    class="dropdown-header"
                                    :class="{ active: appliedSizeLabel }"
                                    @click.stop="toggleDropdown('size')"
                                >
                                <span :style="appliedSizeLabel?'color:#fff':'color:#5d5d5d'">
                                    {{ appliedSizeLabel || $t('Select Size') }}
                                </span>

                                <div style="display:flex;align-items:center;gap:10px;margin-inline-start: 8px;position: relative;top: 1px;">
                                    <i v-if="!sizeOpen" class="bi bi-caret-down-fill" style="font-size: 11px;color: #999;"></i>
                                    <i v-if="sizeOpen" class="bi bi-caret-up-fill" style="font-size: 11px;color: #999;"></i>
                                </div>
                                </div>

                                <div v-if="sizeOpen" class="dropdown-list">
                                
                                    <template v-for="opt in filter.values">    
                                        <div
                                            v-if="opt.value != 'Custom size range'"
                                            :key="opt.value_id"
                                            class="option"
                                            @click="selectSizeOption(opt)"
                                        >
                                            {{ opt.value }}
                                        </div>
                                    </template>    

                                    <div class="custom-row" @click.stop="openCustom('size')">
                                        {{$t('Custom size range')}}
                                    </div>

                                    <div v-if="sizeCustomOpen" @mousedown.stop @click.stop>

                                        <div class="inputs">
                                        <input v-model="sizeMin" type="number" :placeholder="$t('From')">
                                        <input v-model="sizeMax" type="number" :placeholder="$t('To')">

                                        <select v-model="sizeUnit">
                                            <option value="KB">{{$t('KB')}}</option>
                                            <option value="MB">{{$t('MB')}}</option>
                                            <option value="GB">{{$t('GB')}}</option>
                                        </select>
                                        </div>

                                        <div class="actions">
                                            <button class="btn cancel" @click="cancel('size')">{{$t('Cancel')}}</button>
                                            <button class="btn apply" @click="applySize">{{$t('Apply')}}</button>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <remove-field v-if="appliedSizeLabel" class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                        </div>
                        <div v-else-if="filter != undefined && filter.type == 'PICKLIST'" :id="filter.key" class="filter-wrapper" :class="{'apply-background':(filter.default_value && singlePicklistMapper[filter.key] && Object.keys(singlePicklistMapper[filter.key]).length > 0 && singlePicklistMapper[filter.key].value_id != filter.default_value.value_id) || (!filter.default_value && singlePicklistMapper[filter.key] && Object.keys(singlePicklistMapper[filter.key]).length > 0)}">
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <Multiselect
                                v-model="singlePicklistMapper[filter.key]"
                                :options="filter.values"
                                :ref="filter.key"
                                :placeholder="customisePlaceholder(filter.name,'Select')"
                                :searchable="true"
                                :close-on-select="true"
                                :allow-empty="false"
                                track-by="value_id"
                                class="single-selection"
                                label="value"
                                deselectLabel=""
                                selectLabel=""
                                selectedLabel=""
                                @select="picklistSingleSelect(filter.key,$event,filter.filter_type,filter)"
                                style="margin-top: 7px;">
                                <div slot="singleLabel" slot-scope="{ option }">
                                    {{ option.value }}
                                </div>
                                <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                    <span style="margin-inline-start:12px;">{{ scope.option.value}}</span>
                                </div>
                                <span slot="noResult">No results.</span>
                            </Multiselect>
                            <remove-field class="remove-field-styles" v-if="(filter.default_value && singlePicklistMapper[filter.key] && Object.keys(singlePicklistMapper[filter.key]).length > 0 && singlePicklistMapper[filter.key].value_id != filter.default_value.value_id) || (!filter.default_value && singlePicklistMapper[filter.key] && Object.keys(singlePicklistMapper[filter.key]).length > 0)" @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                        </div>
                    </div>

                    <div v-for="filter in selectedFiltersList" :key="filter.key"  v-click-outside="removeSelectedClass" class="selected-filter">
                        <template v-if="filter.type == 'PICKLIST_MULTIVALUE'">
                            <div v-if="filter.key == 'tag_id'" :id="filter.key" class="filter-wrapper apply-background" :class="{focusTheField:autoFocusedField == filter.key}">
                                <div class="filter-label">{{$t(filter.name)}} :</div>
                                <tags-dropdown :ref="filter.key" :selectedTagIds="updatedTagsList" :componentUUID="filter.key" @updatedBulkTagsList="bulkTagsFindCollectionOnSelect" @updatedTagsList="tagsFindCollectionOnSelect" @removedTagsFromList="tagsFindCollectionOnRemove" from="Advanced Search"></tags-dropdown>
                                <remove-field class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                            </div>
                            <div v-else-if="filter.key == 'catalog_id'" :id="filter.key" class="filter-wrapper apply-background" :class="{focusTheField:autoFocusedField == filter.key}">
                                <div class="filter-label">{{$t(filter.name)}} :</div>
                                <CatalogDropdown 
                                :ref="filter.key" 
                                :componentUUID="filter.key" 
                                :enableCatBrowser="false"
                                :selectedCatalogIds="updatedFilteredCatalogsList"
                                from="Advanced Search"
                                @removedCatalogFromList="removedCatalogFromList"
                                @updatedCatalogsList="updatedCatalogsListComp" class="catalog-filter"></CatalogDropdown>
                                <remove-field class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                            </div>
                            <div v-else-if="filter.key == 'label_id'" :id="filter.key" class="filter-wrapper apply-background" :class="{focusTheField:autoFocusedField == filter.key}">
                                <div class="filter-label">{{$t(filter.name)}} :</div>
                                <labelsMultiselect :ref="filter.key" :componentUUID="filter.key" 
                                from="Advanced Search" :selectedLabelsId="updatedLabelsList"
                                @updatedLabelsList="labelsFindCollectionOnSelect" @removedLabelsFromList="labelsFindCollectionOnRemove" class="catalog-filter"></labelsMultiselect>
                                <remove-field class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                            </div>
                            <div v-else class="filter-wrapper apply-background" :id="filter.key" :class="{focusTheField:autoFocusedField == filter.key}">
                                <div class="filter-label">{{$t(filter.name)}} :</div>
                                <Multiselect
                                    v-model="multiPicklistMapper[filter.key]"
                                    :options="filter.values"
                                    :ref="filter.key"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :show-no-results="false"
                                    track-by="value_id"
                                    label="value"
                                    deselectLabel=""
                                    selectLabel=""
                                    selectedLabel=""
                                    :placeholder="customisePlaceholder(filter.name,'Select')"
                                    :hideSelected="false"
                                    :showNoOptions="false"
                                    class="multi-tags-select"
                                    @select="multiPicklistValueTypeOnSelect($event, filter.key,filter.filter_type)"
                                    @remove="multiPicklistValueTypeOnRemove($event, filter.key,filter.filter_type)"
                                    :searchable="true">
                                    <div slot="tag" slot-scope="option" class="selected-tags-style">
                                        <div class="tags-display-style">{{option.option.value}}</div>
                                            <div class="remove-tag" v-on:click="multiPicklistValueTypeOnRemove(option.option,filter.key,filter.filter_type)">
                                                <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                                </svg>
                                            </div>
                                        </div>
                                        <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                        <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makePicklistCheckBoxSelection(scope.option,filter.key)" @focus.prevent :key="scope.option.value_id"/>
                                        <span style="margin-inline-start:12px;">{{ scope.option.value }}</span>
                                    </div>
                                </Multiselect>
                                <remove-field class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                            </div>
                        </template>
                        <div v-if="filter != undefined && (filter.type == 'FREETEXT' || filter.type == 'FREETEXT_MULTILINE')" :id="filter.key" class="filter-wrapper apply-background">
                            
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <input
                                type="text"
                                :ref="filter.key"
                                style="position:relative;top:0px;"
                                class="rounded text-light comm-input-field-style"
                                :placeholder="customisePlaceholder(filter.name,'Enter')"
                                :value="filter.filter_type == 'field' &&  completeFormData['fields'] && completeFormData['fields'][filter.key]? completeFormData['fields'][filter.key] : completeFormData[filter.key] ? completeFormData[filter.key] : ''"
                                @input="filter.filter_type == 'field' ? 
                                    $event.target.value.length ? 
                                        completeFormData['fields'][filter.key] = $event.target.value : delete  completeFormData['fields'][filter.key] : 
                                    $event.target.value.length == 0 ?
                                        delete completeFormData[filter.key] : completeFormData[filter.key] = $event.target.value"
                                autocomplete="off"
                                @keyup.enter="formData(),applyBackgroundForInputTextField[filter.key] && applyBackgroundForInputTextField[filter.key].length != 0?applyBackgroundForInputTextField[filter.key] = true:applyBackgroundForInputTextField[filter.key] = false"
                            />
                            <remove-field class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;color: #a9a9a9;"></remove-field>
                        </div>
                        <div v-if="filter != undefined && filter.type == 'DATE'" :id="filter.key" class="filter-wrapper apply-background">
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <date-picker
                                        range
                                        v-model="dateMappper[filter.key]"
                                        @input="updateDateValue(filter.filter_type,dateMappper[filter.key],filter.key, filter.type)"
                                        :ref="filter.key"
                                        :clearable="false"
                                        valueType="format"
                                        :placeholder="customisePlaceholder(filter.name,'Enter')"
                                        class="text-light comm-input-field-style"
                                        style="padding: 0px;border-radius: 5px;position:relative;top:0px"
                                        @close="dateMappper[filter.key] && dateMappper[filter.key].length > 0?formData():''"
                            ></date-picker>
                            <remove-field class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;color: #a9a9a9;"></remove-field>
                        </div> 
                        <div v-if="filter != undefined && filter.type == 'DATE_TIME'" :id="filter.key" class="filter-wrapper apply-background">
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <date-picker
                                        range
                                        v-model="dateMappper[filter.key]"
                                        @input="updateDateValue(filter.filter_type,dateMappper[filter.key],filter.key, filter.type)"
                                        :ref="filter.key"
                                        :clearable="false"
                                        type="datetime"
                                        valueType="format"
                                        :placeholder="customisePlaceholder(filter.name,'Enter')"
                                        class="text-light comm-input-field-style"
                                        style="padding: 0px;border-radius: 5px;position:relative;top:0px"
                                        @close="dateMappper[filter.key] && dateMappper[filter.key].length > 0?formData():''"
                                        confirm
                            ></date-picker>
                            <remove-field class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;color: #a9a9a9;"></remove-field>
                        </div> 
                        <div v-if="filter != undefined && filter.type == 'INTEGER'" :id="filter.key" class="filter-wrapper apply-background">
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <input
                                type="text"
                                :ref="filter.key"
                                style="position:relative;top:0px"
                                class="rounded text-light comm-input-field-style"
                                :placeholder="customisePlaceholder(filter.name,'Enter')"
                                v-model="integerMapper[filter.key]"
                                @input="customiseIntegerPostDataBasedOnType(filter.filter_type,$event.target.value,filter.key)"
                                autocomplete="off"
                                @keypress="acceptOnlyNumbers($event)"
                                @keyup.enter="formData()"
                            />
                            <remove-field class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;color: #a9a9a9;"></remove-field>
                        </div>
                        <div v-if="filter != undefined && filter.type == 'users'" :id="filter.key" class="filter-wrapper apply-background">
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <users-multiselect :ref="filter.key" :componentUuid="filter.key" :selectedUserIdList="usersFilterMapper[filter.key]" :enableCheckbox="true" :isSearchable="true" @updatedUsersList='updatedUsersList' @removedUserFromList='removedUserFromList'></users-multiselect>
                            <remove-field class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;width: 50px;color: #a9a9a9;"></remove-field>
                        </div>
                        <div v-if="filter != undefined && filter.type == 'PICKLIST' && filter.key == 'created_on'" :id="filter.key" class="filter-wrapper apply-background">
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <date-picker
                                    v-if="['after_date','before_date','on_date'].includes(selectedCreatedDateValue.value_id)"
                                    :range="false"
                                    v-model="createdDateCustomFilterValSingleVal"
                                    @input="updatePrimayCreatedOnSingleSelectFilterValue('created_on',createdDateCustomFilterValSingleVal,selectedCreatedDateValue.value_id)"
                                    :clearable="false"
                                    valueType="format"
                                    ref="createdOnSingle"
                                    placeholder=''
                                    class="text-light comm-input-field-style"
                                    style="padding: 0px;border-radius: 5px;position:relative;top:0px;width:170px"
                                    >
                                    <template slot="input" slot-scope="{ picker }">
                                    {{selectedCreatedDateValue.value}} {{createdDateCustomFilterValSingleVal}} {{ picker }}
                                    </template>
                            </date-picker>
                            <date-picker
                                    v-click-outside='hidePicker'
                                    v-else-if="selectedCreatedDateValue.value_id == 'year_range'"
                                    range
                                    v-model="createdDateCustomFilterValForYearRange"
                                    @input="updatePrimayCreatedOnFilterValue('created_on',createdDateCustomFilterValForYearRange,selectedCreatedDateValue.value_id,'year')"
                                    :clearable="false"
                                    valueType="format"
                                    ref="createdOnYearRange"
                                    placeholder=''
                                    type="year"
                                    format="YYYY"
                                    :max-year="getCurrentYear()"
                                    class="text-light comm-input-field-style"
                                    style="padding: 0px;border-radius: 5px;position:relative;top:0px;width:210px"
                                    @clear="selectedCreatedDateValue = {}"
                            ></date-picker>
                            <date-picker
                                v-click-outside='hidePicker'
                                v-else-if="selectedCreatedDateValue.value_id == 'range'"
                                range
                                v-model="createdDateCustomFilterVal"
                                @input="updatePrimayCreatedOnFilterValue('created_on',createdDateCustomFilterVal,selectedCreatedDateValue.value_id)"
                                :clearable="false"
                                valueType="format"
                                ref="createdOnRange"
                                placeholder=''
                                class="text-light comm-input-field-style"
                                style="padding: 0px;border-radius: 5px;position:relative;top:0px;width:210px"
                                @clear="selectedCreatedDateValue = {}"
                            ></date-picker>
                            <Multiselect
                                v-else
                                v-model="selectedCreatedDateValue"
                                :options="filter.values"
                                placeholder=""
                                :searchable="true"
                                :close-on-select="true"
                                :allow-empty="false"
                                track-by="value_id"
                                label="value"
                                deselectLabel=""
                                selectLabel=""
                                selectedLabel=""
                                @select="updateCreatedOnFilter('created_on',$event)"
                                style="margin-top: 7px;">
                                <div slot="singleLabel" slot-scope="{ option }">
                                    {{ option.value }}
                                </div>
                                <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                    <span style="margin-inline-start:12px;">{{ scope.option.value}}</span>
                                </div>
                                <span slot="noResult">No results.</span>
                            </Multiselect>
                            <remove-field class="remove-field-styles" v-if="Object.keys(selectedCreatedDateValue).length" @click.native="selectedCreatedDateValue = {}, createdDateCustomFilterValSingleVal = null, createdDateCustomFilterVal = null,createdDateCustomFilterValForYearRange = null, delete completeFormData['created_on'], formData()" style="height: 30px;color: #a9a9a9" :style="['after_date','before_date','on_date','range','year_range'].includes(selectedCreatedDateValue.value_id)?'width:30px':'width:60px'"></remove-field>
                        </div>
                        <div v-else-if="filter != undefined && filter.type == 'PICKLIST' && filter.key == 'duration'" class="filter-wrapper comm-custom-range-fields" :class="{'apply-background':appliedLabel && appliedLabel.length}">
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <div class="dropdown" v-click-outside="closeDurationDropdown">
                                <!-- HEADER -->
                                <div
                                    class="dropdown-header"
                                    :class="{ active: appliedLabel }"
                                    @click.stop="toggleDropdown('duration')"
                                >
                                <span class="selected-value-div" :style="appliedLabel?'color:#fff':'color:#5d5d5d'">
                                        {{ appliedLabel || 'Select duration' }}
                                    </span>

                                    <div style="display:flex;align-items:center;gap:10px;margin-inline-start: 8px;position: relative;top: 1px;">
                                        <i v-if="!open" class="bi bi-caret-down-fill" style="font-size: 11px;color: #999;"></i>
                                        <i v-if="open" class="bi bi-caret-up-fill" style="font-size: 11px;color: #999;"></i>
                                    </div>
                                </div>

                                <div v-if="open" class="dropdown-list">

                                    <template v-for="opt in filter.values">    
                                        <div
                                            v-if="opt.value != 'Custom duration range'"
                                            :key="opt.value_id"
                                            class="option"
                                            @click="selectDurationOption(opt)"
                                        >   
                                            {{ opt.value }}
                                        </div>
                                    </template>   

                                    <div class="custom-row" @click.stop="openCustom('duration')">
                                        {{$t('Custom duration range')}}
                                    </div>

                                    <div v-if="customOpen" @mousedown.stop @click.stop>

                                        <div class="inputs">
                                        <input v-model="min" type="number" :placeholder="$t('From')">
                                        <input v-model="max" type="number" :placeholder="$t('To')">

                                        <select v-model="unit">
                                            <option value="Sec">{{$t('Sec')}}</option>
                                            <option value="Min">{{$t('Min')}}</option>
                                            <option value="Hr">{{$t('Hr')}}</option>
                                        </select>
                                        </div>

                                        <div class="actions">
                                            <button class="btn cancel" @click="cancel('duration')">{{$t('Cancel')}}</button>
                                            <button class="btn apply" @click="apply">{{$t('Apply')}}</button>
                                        </div>

                                    </div>

                                    </div>
                            </div>
                            <remove-field v-if="appliedLabel" class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                        </div>
                        <div v-else-if="filter != undefined && filter.type == 'PICKLIST' && filter.key == 'size'" class="filter-wrapper comm-custom-range-fields" :class="{'apply-background':appliedSizeLabel && appliedSizeLabel.length}">
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <div class="dropdown" v-click-outside="closeSizeDropdown">
                                <div
                                class="dropdown-header"
                                :class="{ active: appliedSizeLabel }"
                                @click.stop="toggleDropdown('size')"
                                >
                                <span class="selected-value-div" :style="appliedSizeLabel?'color:#fff':'color:#5d5d5d'">
                                    {{ appliedSizeLabel || $t('Select Size') }}
                                </span>

                                <div style="display:flex;align-items:center;gap:10px;margin-inline-start: 8px;position: relative;top: 1px;">
                                    <i v-if="!sizeOpen" class="bi bi-caret-down-fill" style="font-size: 11px;color: #706f6f;"></i>
                                    <i v-if="sizeOpen" class="bi bi-caret-up-fill" style="font-size: 11px;color: #706f6f;"></i>
                                </div>
                                </div>

                                <div v-if="sizeOpen" class="dropdown-list">
                                
                                    <template v-for="opt in filter.values">    
                                        <div
                                            v-if="opt.value != 'Custom size range'"
                                            :key="opt.value_id"
                                            class="option"
                                            @click="selectSizeOption(opt)"
                                        >
                                            {{ opt.value }}
                                        </div>
                                    </template>    

                                    <div class="custom-row" @click.stop="openCustom('size')">
                                        {{$t('Custom size range')}}
                                    </div>

                                    <div v-if="sizeCustomOpen" @mousedown.stop @click.stop>

                                        <div class="inputs">
                                        <input v-model="sizeMin" type="number" :placeholder="$t('From')">
                                        <input v-model="sizeMax" type="number" :placeholder="$t('To')">

                                        <select v-model="sizeUnit">
                                            <option value="KB">{{$t('KB')}}</option>
                                            <option value="MB">{{$t('MB')}}</option>
                                            <option value="GB">{{$t('GB')}}</option>
                                        </select>
                                        </div>

                                        <div class="actions">
                                            <button class="btn cancel" @click="cancel('size')">{{$t('Cancel')}}</button>
                                            <button class="btn apply" @click="applySize">{{$t('Apply')}}</button>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <remove-field v-if="appliedSizeLabel" class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                        </div>
                        <div v-else-if="filter != undefined && filter.type == 'PICKLIST'" :id="filter.key" class="filter-wrapper apply-background">
                            <div class="filter-label">{{$t(filter.name)}} :</div>
                            <Multiselect
                                v-model="singlePicklistMapper[filter.key]"
                                :options="filter.values"
                                :ref="filter.key"
                                :placeholder="customisePlaceholder(filter.name,'Select')"
                                :searchable="true"
                                :close-on-select="true"
                                :allow-empty="false"
                                track-by="value_id"
                                class="single-selection"
                                label="value"
                                deselectLabel=""
                                selectLabel=""
                                selectedLabel=""
                                @select="picklistSingleSelect(filter.key,$event,filter.filter_type,filter)"
                                style="margin-top: 7px;">
                                <div slot="singleLabel" slot-scope="{ option }">
                                    {{ option.value }}
                                </div>
                                <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                    <span style="margin-inline-start:12px;">{{ scope.option.value}}</span>
                                </div>
                                <span slot="noResult">No results.</span>
                            </Multiselect>
                            <remove-field v-if="(filter.default_value && singlePicklistMapper[filter.key] && Object.keys(singlePicklistMapper[filter.key]).length > 0 && singlePicklistMapper[filter.key].value_id != filter.default_value.value_id) || (singlePicklistMapper[filter.key] && Object.keys(singlePicklistMapper[filter.key]).length > 0)" class="remove-field-styles" @click.native="removeSelectedFilter(filter)" style="height: 30px;width:50px;color: #a9a9a9;"></remove-field>
                        </div>
                    </div>

                    <div class="add-search-filter selected-filter filter-wrapper" @click="openSearchFilters('filtersField')">
                        <div v-if="changeTextOfAddField != undefined && changeTextOfAddField.length" class="filter-label" style="margin-inline-start: 40px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-funnel-fill mb-1" viewBox="0 0 16 16">
                                <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"/>
                            </svg>{{changeTextOfAddField}}</div>
                        <div v-else class="filter-label" style="margin-inline-start: 40px">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-funnel-fill mb-1" viewBox="0 0 16 16">
                                <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"/>
                            </svg>More filter</div>
                        <Multiselect
                            v-model="selectedFiltersList" 
                            :options="filtersList"
                            ref="filtersField"
                            :multiple="true"
                            track-by="key"
                            label="name"
                            :close-on-select="true"
                            :show-no-results="false"
                            placeholder=""
                            deselectLabel =""
                            selectLabel=""
                            selectedLabel=""
                            :hideSelected="false"
                            :showNoOptions="false"
                            @open="changeTextOfAddField = 'Select filter'"
                            @close="changeTextOfAddField = 'Add filter'"
                            @remove="removeSelectedFilter($event)"
                            @select="selectFilter($event)">
                            <span slot="noResult">No results</span>
                            <span slot="noOptions" style="display:none"></span>
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                            <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeFiltersCheckboxAction(scope.option)" @focus.prevent :key="scope.option.name"/>
                            <span style="margin-inline-start:12px;">{{ $t(scope.option.name) }}</span>
                            </div>
                        </Multiselect>
                    </div>
                    <div style="display:flex;align-items:center">
                        <div @click="resetFields()" class="reset-button">Reset</div>
                        <div  v-if="!disableEditMode" @click="enableAddFav = true" class="reset-button ml-0">Save</div>
                        <div v-if="!disableEditMode" title="Pin Advanced Search" @click="updateSelectedUserFilter()" class="reset-button ml-0 p-1">
                            <svg v-if="!pinnedFilter" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-pin-angle" viewBox="0 0 16 16">
                                <path d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a6 6 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707s.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a6 6 0 0 1 1.013.16l3.134-3.133a3 3 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146m.122 2.112v-.002zm0-.002v.002a.5.5 0 0 1-.122.51L6.293 6.878a.5.5 0 0 1-.511.12H5.78l-.014-.004a5 5 0 0 0-.288-.076 5 5 0 0 0-.765-.116c-.422-.028-.836.008-1.175.15l5.51 5.509c.141-.34.177-.753.149-1.175a5 5 0 0 0-.192-1.054l-.004-.013v-.001a.5.5 0 0 1 .12-.512l3.536-3.535a.5.5 0 0 1 .532-.115l.096.022c.087.017.208.034.344.034q.172.002.343-.04L9.927 2.028q-.042.172-.04.343a1.8 1.8 0 0 0 .062.46z"/>
                            </svg>
                            <svg v-else xmlns="http://www.w3.org/2000/svg" :class="{pinned:pinnedFilter}" width="20" height="20" fill="currentColor" class="bi bi-pin-angle-fill" viewBox="0 0 16 16">
                                <path d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a6 6 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707s.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a6 6 0 0 1 1.013.16l3.134-3.133a3 3 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146"/>
                            </svg>
                        </div>
                        <div v-if="!enableConfigMode && !disableEditMode" class="reset-button ml-0 p-1"><svg  xmlns="http://www.w3.org/2000/svg" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" width="20" height="20" fill="currentColor" class="bi bi-three-dots-vertical more-actions-icon icon-background-on-hover dropdown-toggle ml-0" viewBox="0 0 16 16">
                            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                        </svg>
                        <div v-if="!disableEditMode" class="dropdown-menu dropdown-menu-md-right p-0" style="max-height: 400px;overflow: auto;">
                            <a @click="enableConfigMode = true" class="dropdown-item p-2">
                                <span>{{$t('Edit')}}</span>
                            </a>
                            <a @click="hideAdvancedSearch()" class="dropdown-item p-2">
                                <span>{{$t('Hide Advanced Search')}}</span>
                            </a>
                            <a @click="showFavouritesInMyPreferences()" class="dropdown-item p-2">
                                <span>{{$t('Manage Saved Search')}}</span>
                            </a>
                            <hr style="border-top: 1px solid #353535;margin: 6px;">
                            <a v-for="fav in getOnlySavedSearch" @click="loadSelectedFavourite(fav)" :key="fav._id" class="dropdown-item p-2">
                                <div v-if="getfavThumbnail(fav)" style="height: 25px;width: 25px;">
                                    <img :src="getfavThumbnail(fav)" style="height:100%;width:100%;border-radius: 7px;">
                                </div>
                                <div v-else v-html="savedSearchSVG" class="text-center" style="position:relative"></div>
                                <div class="ml-2">{{fav.name}}</div>
                            </a>
                        </div></div>
                    </div>
                </template>
                <template v-if="enableConfigMode && !disableEditMode">
                    <div class="filter-wrapper selected-filter config-filters  global-filter-tag">
                        Global filters
                    </div>
                    <template>
                        <div v-for="gItem in selectedGlobalConfigFiltersList" :key="'global'+gItem.key" :class="{notAdminType: !isEnabled('manage-search-filter')}" class="filter-wrapper selected-filter config-filters">
                            <div class="filter-label mr-2">{{$t(gItem.name)}}</div>
                            <remove-field class="remove-field-styles" v-if="isEnabled('manage-search-filter')" @click="removeSelectedGlobalFilter(gItem)"></remove-field>
                        </div>
                        <div v-if="isEnabled('manage-search-filter')" class="add-search-filter selected-filter filter-wrapper config-add-filter" style="margin-top:4px !important" @click="openSearchFilters('globalFiltersField')">
                            <div class="filter-label" style="margin-inline-start: 40px">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-funnel-fill mb-1" viewBox="0 0 16 16">
                                    <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"/>
                                </svg>{{$t("Add filter")}}</div>
                            <Multiselect
                                v-model="selectedGlobalConfigFiltersList" 
                                :options="globalFiltersDropdown"
                                ref="globalFiltersField"
                                :multiple="true"
                                track-by="key"
                                label="name"
                                :close-on-select="true"
                                :show-no-results="false"
                                placeholder=""
                                deselectLabel =""
                                selectLabel=""
                                selectedLabel=""
                                :hideSelected="false"
                                :showNoOptions="false"
                                @open="changeTextOfAddField = 'Select filter'"
                                @close="changeTextOfAddField = 'Add filter'"
                                @remove="removeSelectedGlobalFilter($event)"
                                @select="selectGlobalFilter($event)">
                                <span slot="noResult">No results</span>
                                <span slot="noOptions" style="display:none"></span>
                                <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeGlobalFiltersCheckboxAction(scope.option)" @focus.prevent :key="scope.option.name"/>
                                <span style="margin-inline-start:12px;">{{ $t(scope.option.name) }}</span>
                                </div>
                            </Multiselect>
                        </div>
                    </template>
                    <div style="display: flex;align-items: center;height: 33px;width: 3px;background: #4a4a4a;margin-top: 8px;border-radius: 5px;margin: 0px 15px;position: relative;inset-inline-start:0px;"></div>
                    <template v-if="enableConfigMode">
                        <div class="filter-wrapper selected-filter config-filters ml-0 user-filter-tag">
                            My filters
                        </div>
                        <div v-for="uItem in selectedUserConfigFiltersList" :key="'user'+uItem.key" class="filter-wrapper selected-filter config-filters">
                            <div class="filter-label">{{$t(uItem.name)}}</div>
                            <remove-field class="remove-field-styles" @click="removeSelectedUserFilter(uItem)"></remove-field>
                        </div>
                        <div class="add-search-filter selected-filter filter-wrapper config-add-filter" style="margin-top:4px !important" @click="openSearchFilters('userFiltersField')">
                            <div class="filter-label" style="margin-inline-start: 40px">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-funnel-fill mb-1" viewBox="0 0 16 16">
                                    <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"/>
                                </svg>Add filter</div>
                            <Multiselect
                                v-model="selectedUserConfigFiltersList" 
                                :options="userFiltersDropdown"
                                ref="userFiltersField"
                                :multiple="true"
                                track-by="key"
                                label="name"
                                :close-on-select="true"
                                :show-no-results="false"
                                placeholder=""
                                deselectLabel=""
                                selectLabel=""
                                selectedLabel=""
                                :hideSelected="false"
                                :showNoOptions="false"
                                @remove="removeSelectedUserFilter($event)"
                                @select="selectUserFilter($event)">
                                <span slot="noResult">No results</span>
                                <span slot="noOptions" style="display:none"></span>
                                <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeUserFiltersCheckboxAction(scope.option)" @focus.prevent :key="scope.option.name"/>
                                <span style="margin-inline-start:12px;">{{ $t(scope.option.name)}}</span>
                                </div>
                            </Multiselect>
                        </div>
                    </template>
                    <div @click="enableConfigMode = false" class="reset-button blinking-button">Exit</div>
                </template>
            </div>
            <reload-panel v-if="openReloadPanel" :message="reloadPanelMessage" @closeReloadPanel="closeReloadPanel" @reloadButtonClicked="reloadButtonClicked"></reload-panel>
            <addSavedSearch ref="addOrEditFav" v-if="enableAddFav" v-bind="currentProperties" @close="enableAddFav=false" @validateSearchQuery="validatedSearchQuery"></addSavedSearch>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import {mapActions, mapMutations, mapGetters} from "vuex";
import TagDropDownComponent from "../tags/TagsSelectionDropdown.vue";
import CatalogDropdown from "../categories/CatalogMultiselectDropdown.vue";
import UsersMultiselect  from "../users/UserMultiselectField.vue";
import DatePicker from "vue2-datepicker";
import RemoveField from "../core/InlineCancelField.vue";
import {NotifierConstants} from "../../components.constants.js";
import labelsMultiselect from "../../components/labels/LabelsMultiselectDropdown.vue";
import Utils from '../../components.utils';
import reloadPanel from "./AdvancedSearchReloadPanel.vue";
import addSavedSearch from "../Favorites/AddOrEditBookMark.vue";

export default {
    props:["searchContext", "compType","appliedValues","favoritesList","disableEditMode","isNLPSearchMode"],
    data(){
        return{
            restoredFilterPreferencesKey:null,
            routeQuery:[],
            filtersList:[],
            selectedFilter:{},
            selectedFiltersList:[],
            updatedTagsList:[],
            updatedLabelsList:[],
            usersFilterMapper:{},
            completeFormData:{"fields":{}},
            updatedFilteredCatalogsList:[],
            show:false,
            autoFocusedField:"",
            multiPicklistMapper:{},
            singlePicklistMapper:{},
            integerMapper:{},
            dateMappper:{},
            changeTextOfAddField:"",
            fieldLength:80,
            selectedFindWithValue:{"label":"Any word","key":"any"},
            findWithFilterList:[
                {"label":"Any word","key":"any"},
                {"label":"All words","key":"all"},
                {"label":"Exact word","key":"exact"},
            ],
            selectedFindInValue:{"label":"Any","key":"any"},
            findInFilterList:[
                {"label":"Any","key":"any"},
                // {"label":"Slug name","key":"slug_name"},
                {"label":"File name","key":"file_name"},
                {"label":"Description","key":"description"},
                {"label":"Content","key":"content"}
            ],
            selectedMimeTypeValue:[],
            mimeTypeOptionsArr:[],
            selectedCreatedDateValue:{},
            createdDateCustomFilterValSingleVal:null,
            createdDateCustomFilterVal:null,
            createdDateCustomFilterValForYearRange:null,
            createdDateOptionsArr:[],
            globalFilters:[],
            openCreatedOnDatePicker:false,
            applyBackgroundForInputTextField:{},
            enableAddFav:false,
            showConfigDropdown:false,
            enableConfigMode:false,
            selectedGlobalConfigFiltersList:[],
            selectedUserConfigFiltersList:[],
            globalFiltersDropdown:[],
            userFiltersDropdown:[],
            pinnedGlobalFilters:false,
            pinnedFilter:false,
            userFilters:[],
            combinedFilters:[],
            valuesToBePopulated:{},
            selectedCatalogPIcklist:'',
            openReloadPanel:false,
            reloadPanelMessage:'',
            savedSearchSVG:Utils.getSavedSearchSvg(),
            promiseFiltersList:null,
            tempFiltersList:null,
            open: false,
            customOpen: false,
            appliedLabel: '',
            min: '',
            max: '',
            unit: 'Sec',
            sizeOpen: false,
            sizeCustomOpen: false,
            appliedSizeLabel: '',
            sizeMin: '',
            sizeMax: '',
            sizeUnit: 'KB',
        }
    },
    components:{
        "Multiselect":Multiselect,
        "tags-dropdown":TagDropDownComponent,
        "users-multiselect":UsersMultiselect,
        CatalogDropdown,
        "date-picker":DatePicker,
        "remove-field":RemoveField,
        labelsMultiselect,
        "reload-panel":reloadPanel,
        addSavedSearch
    },
    computed:{
        getOnlySavedSearch(){
            return this.favoritesList.filter(e => e.type == 'Saved Search');
        },
        checkIfNotAdvancedSearch(){
            if(this.searchContext == 'query-builder-in-reports'){
                return false;
            }
            return true;
        },
        currentProperties() {
            return {favInfo : {name:"",type:"Saved Search"}, newFav:"true"}
        },
        barcodeInfoFromStartup:{
            get(){
                return this.$store.state.startUpData.startUpDataDetails;
            }
        },
    },
    methods:{
        filterPreferencesKey(){
            return 'advanced_search_dropdowns:' + this.getLoggedInUserId() + ':' + this.searchContext;
        },
        validateFilterPreferences(preferences){
            const isPlainObject = value => value !== null && typeof value === 'object' &&
                Object.getPrototypeOf(value) === Object.prototype;
            if(!isPlainObject(preferences))return null;
            const keys = Object.keys(preferences);
            if(!keys.length || keys.some(key => !['search_in', 'search_as', 'created_on', 'createdOnOption'].includes(key)))return null;
            const filters = this.combinedFilters.concat(this.filtersList || []);
            const validated = {};
            for(const key of ['search_in', 'search_as', 'created_on']){
                if(!Object.prototype.hasOwnProperty.call(preferences, key))continue;
                const filter = filters.find(item => item.key === key);
                if(!filter || !Array.isArray(filter.values))return null;
                const value = preferences[key];
                let optionId = value;
                if(key === 'search_in'){
                    if(typeof value !== 'string')return null;
                    let ids;
                    try{
                        ids = JSON.parse(value);
                    }catch(error){
                        return null;
                    }
                    if(!Array.isArray(ids) || ids.length !== 1 || typeof ids[0] !== 'string')return null;
                    optionId = ids[0];
                }else if(key === 'created_on'){
                    if(!isPlainObject(value))return null;
                    optionId = value.type;
                    if(preferences.createdOnOption !== optionId)return null;
                    const dateFields = {
                        on_date: ['value'], before_date: ['to_value'], after_date: ['from_value'],
                        range: ['from_value', 'to_value'], year_range: ['from_value', 'to_value']
                    };
                    // Custom dates need inputs; other configured options are relative dates.
                    // The option must still exist in filter.values (checked below).
                    const required = Object.prototype.hasOwnProperty.call(dateFields, optionId)
                        ? dateFields[optionId] : [];
                    if(Object.keys(value).some(field => !['type'].concat(required).includes(field)))return null;
                    for(const field of required){
                        const date = value[field];
                        if(typeof date !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(date))return null;
                        const parsed = new Date(date + 'T00:00:00.000Z');
                        if(isNaN(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== date)return null;
                    }
                    if(required.length === 2 && value.from_value > value.to_value)return null;
                    if(optionId === 'year_range' && (!value.from_value.endsWith('-01-01') || !value.to_value.endsWith('-12-31')))return null;
                }
                if(typeof optionId !== 'string')return null;
                const option = filter.values.find(item => item.value_id === optionId);
                if(!option)return null;
                validated[key] = {option, value};
            }
            if(Object.prototype.hasOwnProperty.call(preferences, 'createdOnOption') && !validated.created_on)return null;
            return Object.keys(validated).length ? validated : null;
        },
        clearFilterPreferences(){
            if(this.searchContext === 'query-builder-in-reports')return;
            try{
                localStorage.removeItem(this.filterPreferencesKey());
            }catch(error){
                console.warn('Unable to clear search dropdown preferences', error);
            }
        },
        saveFilterPreferences(){
            if(this.searchContext === 'query-builder-in-reports')return;
            const preferences = {};
            // An unfinished date must not discard valid Search in/with preferences.
            for(const key of ['search_in', 'search_as', 'created_on']){
                if(this.completeFormData[key] === undefined)continue;
                const candidate = {[key]: this.completeFormData[key]};
                if(key === 'created_on'){
                    candidate.createdOnOption = this.selectedCreatedDateValue && this.selectedCreatedDateValue.value_id;
                }
                if(this.validateFilterPreferences(candidate))Object.assign(preferences, candidate);
            }
            if(!Object.keys(preferences).length){
                this.clearFilterPreferences();
                return;
            }
            try{
                localStorage.setItem(this.filterPreferencesKey(), JSON.stringify(preferences));
            }catch(error){
                console.warn('Unable to save search dropdown preferences', error);
            }
        },
        restoreFilterPreferences(){
            if(this.searchContext === 'query-builder-in-reports')return;
            if(this.searchContext === 'query-builder-in-reports')return;

            // Restore main workspace preferences only on the catalog route.
            if(
                this.compType === 'mainComp' &&
                this.$route.name !== 'catalogs-display'
            ){
                return;
            }

            const storageKey = this.filterPreferencesKey();
            if(this.restoredFilterPreferencesKey === storageKey)return;
            // A keyword clear can keep other filters while removing search_in/search_as.
            // Restore only missing search preferences; explicit values always win.
            const explicitFilters = [this.completeFormData, this.routeQuery];
            const hasQueryFilters = query => {
                if(!query)return false;
                return Object.keys(query).some(key => {
                    if(key === 'page')return false;
                    if(key === 'keyword')return typeof query[key] !== 'string';
                    if(key !== 'advanceFilter')return true;
                    try{
                        const filters = JSON.parse(query[key]);
                        if(!filters || typeof filters !== 'object' || Array.isArray(filters))return true;
                        explicitFilters.push(filters);
                        return false;
                    }catch(error){
                        return true;
                    }
                });
            };
            if(this.appliedValues !== undefined && this.appliedValues !== null)return;
            if(hasQueryFilters(this.$route.query) || hasQueryFilters(this.valuesToBePopulated))return;
            if(this.searchContext === 'query-builder-in-reports')return;
            let validated;
            try{
                const stored = localStorage.getItem(storageKey);
                if(!stored)return;
                validated = this.validateFilterPreferences(JSON.parse(stored));
            }catch(error){
                this.clearFilterPreferences();
                return;
            }
            if(!validated){
                this.clearFilterPreferences();
                return;
            }
            // Compare request payloads so UI-only restoration does not trigger another search.
            const previousPayload = JSON.stringify(this.getSearchRequestFilters(this.completeFormData));
            // Validation finishes before any UI or payload mutation.
            let restored = false;
            for(const key of Object.keys(validated)){
                if(explicitFilters.some(filters => filters && Object.prototype.hasOwnProperty.call(filters, key)))continue;
                if(!this.combinedFilters.some(filter => filter.key === key))continue;
                const {option, value} = validated[key];
                if(key === 'created_on'){
                    this.selectedCreatedDateValue = option;
                    this.createdDateCustomFilterVal = value.type === 'range' ? [value.from_value, value.to_value] : null;
                    this.createdDateCustomFilterValForYearRange = value.type === 'year_range' ?
                        [value.from_value.slice(0, 4), value.to_value.slice(0, 4)] : null;
                    this.createdDateCustomFilterValSingleVal = value.value || value.from_value || value.to_value || null;
                }else{
                    this.singlePicklistMapper = Object.assign({}, this.singlePicklistMapper, {[key]: option});
                }
                this.$set(this.completeFormData, key, value);
                restored = true;
            }
            if(restored)this.restoredFilterPreferencesKey = storageKey;
            if(restored && previousPayload !== JSON.stringify(this.getSearchRequestFilters(this.completeFormData))){
                this.$emit("advancedSearchData", this.getSearchRequestFilters(this.completeFormData));
            }
        },
        //Generic----------------------------------------------------------
        hideAdvancedSearch(){
            if(this.pinnedFilter){
                if(confirm("Advanced search bar is pinned. Do you want to unpin and hide?")){
                    this.pinnedFilter = false;
                    let payload = {
                        "pinned_filters":false,
                        "name":"catalog_workspace"
                    }
                    this.updateUserFilters(payload).then((data) => {
                        if (data.statusCode == 200) {
                            this.$toast.success(data.message);
                        } else {
                            this.$toast.error(data.message);
                        }
                    })
                }
            }
            this.$emit("hideAdvancedSearch");
        },
        getCurrentYear(){
            return new Date().getFullYear()
        },
        hidePicker(){
            this.openCreatedOnDatePicker = false;
        },
        customisePlaceholder(name,prefix){
            return `${prefix +" "+ name}`;
        },
        acceptOnlyNumbers(event){
            let regex = new RegExp(/^[0-9]|[-]$/);
            let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        },
        getfavThumbnail(favInfo){
            if(favInfo.cover_photo && favInfo.cover_photo.length > 0){
            return Utils.convertToLoginIPDomainName(favInfo.cover_photo);
            }else{
            return null
            }
        },
        showFavouritesInMyPreferences(){
            this.$emit("showFavouritesInMyPreferences",'user-info')
        },
        loadSelectedFavourite(favInfo){
            this.$emit("loadSelectedFavourite",favInfo)
        },
        //-----------------------------------------------------------------
        //Filters dropdown construction----------------------------------------------
        selectFilter(option){
            let index = this.filtersList.findIndex(item => item.key == option.key);
                 if(index > -1){
                     this.filtersList[index].checked = true;
                    //  this.selectedFiltersList.push(option);
                     this.$nextTick(() => {
                         let autoFocusedField = option.key;
                         setTimeout(() => {
                                if (this.$refs[autoFocusedField]) {
                                    this.autoFocusInputFields(autoFocusedField,option.type)
                                }
                         }, 200);
                     })
                 }
        },
        autoFocusInputFields(keyName,custMetadataType){
            document.getElementsByClassName('focusTheField').forEach(el => el.classList.remove("focusTheField"))
            if(keyName == 'catalog_id'){
                this.$refs[keyName][0].$el.firstElementChild.firstElementChild.focus();
            }
            if(['INTEGER','FREETEXT','FREETEXT_MULTILINE',"DATE","DATE_TIME"].includes(custMetadataType)){
                this.$refs[keyName][0].focus();
            }
            if(['PICKLIST_MULTIVALUE','PICKLIST','users','tags'].includes(custMetadataType)){
                setTimeout(() => {
                    if(this.$refs[keyName][0])this.$refs[keyName][0].$el.focus();
                }, 200);
            }
            if( document.getElementById(keyName))document.getElementById(keyName).classList.add("focusTheField");
        },
        removeFilter(option){
            let index = this.filtersList.findIndex(item => item.key == option.key);
                 if(index > -1){
                     this.filtersList[index].checked = false;
                 }
        },
        makeFiltersCheckboxAction(option){
            return this.selectedFiltersList.some((op) => op.key === option.key);
        },
        //Mimetype filter----------------------------------------------------------
        makeMimeTypeFilterCheckboxAction(option){
                return this.selectedMimeTypeValue.some((op) => op === option);
        },

        selectMimeTypeFilter(selectedOption,optionsArr){
            let index = optionsArr.findIndex(item => item.value_id == selectedOption.value_id);
                 if(index > -1){
                     optionsArr[index].checked = true;
                 }
                 setTimeout(() => {
                        this.completeFormData['mime_type'] = JSON.stringify(this.getOnlyValuesOfMimetypes(this.selectedMimeTypeValue));
                        this.formData();
                 }, 200);
        },

        removeSelectedMimeTypeFilter(selectedOption,optionsArr){
            let index = optionsArr.findIndex(item => item.value_id == selectedOption.value_id);
            if(index > -1){
                optionsArr[index].checked = false;
            }
            this.completeFormData['mime_type'] = JSON.stringify(this.getOnlyValuesOfMimetypes(this.selectedMimeTypeValue));
            if(this.selectedMimeTypeValue.length == 0){
                delete this.completeFormData['mime_type'];
            }
            this.formData();
        },
        removeSelectedMimeTypeFilterFromTag(selectedOption){
            this.selectedMimeTypeValue = this.selectedMimeTypeValue.filter(e => e.value_id != selectedOption.value_id);
            this.completeFormData['mime_type'] = JSON.stringify(this.getOnlyValuesOfMimetypes(this.selectedMimeTypeValue));
            if(this.selectedMimeTypeValue.length == 0){
                delete this.completeFormData['mime_type'];
            }
            this.formData();
        },
        getOnlyValuesOfMimetypes(arr){
            let temp = [];
            for(let i = 0; i<arr.length;i++){
                temp.push(arr[i].value_id);
            }
            return temp;
        },
        //---------------------------------------------------------------------------
        //Picklist Multivalue-----------------------------------------------------------
        multiPicklistValueTypeOnSelect(option,key,type){
            if(type =='field'){
                if(this.completeFormData["fields"][key] == undefined){
                    this.completeFormData["fields"][key] = [];
                }else{
                    this.completeFormData["fields"][key];
                }
                this.completeFormData["fields"][key].push(option.value_id);
                let temp = this.$refs[key][0].value;
                let indx = temp.findIndex(op=>op.value_id == option.value_id);
                if(indx < 0){
                    temp.push(option);
                    this.$set(this.$refs[key][0], "value", temp)
                    this.$forceUpdate();
                    // this.$refs[key][0].value = temp
                }
                // this.$set(this.multiPicklistMapper[key],this.completeFormData["fields"][key])
                // if(this.multiPicklistMapper && Object.keys(this.multiPicklistMapper).includes(key)){
                //     this.multiPicklistMapper[key].push(option);
                // }else{
                //     this.multiPicklistMapper[key] = [option]
                // }
                this.formData();
            }else{
                if(this.completeFormData[key] == undefined){
                    this.completeFormData[key] = [];
                }else{
                    this.completeFormData[key] = JSON.parse(this.completeFormData[key])
                }
                this.completeFormData[key].push(option.value_id);
                this.completeFormData[key] = JSON.stringify(this.completeFormData[key])
                this.formData();
            }
        },
        multiPicklistValueTypeOnRemove(option,key,type){
            if(type =='field'){
                this.completeFormData["fields"][key] = this.completeFormData["fields"][key].filter(e => e != option.value_id);
                if(this.completeFormData["fields"][key].length == 0){
                    delete this.completeFormData["fields"][key];
                }
                // this.$refs[key][0].value = this.$refs[key][0].value.filter(op=>op.value_id != option.value_id);
                if(this.$refs[key] && this.$refs[key].length > 0){
                    let indx = this.$refs[key][0].value.findIndex(op=>op.value_id == option.value_id);
                    if(indx >= 0){
                        this.$refs[key][0].value.splice(indx, 1);
                        this.$forceUpdate();
                        this.makePicklistCheckBoxSelection(option,key)
                    }
                }

                this.formData();
            }else{
                this.completeFormData[key] = JSON.parse(this.completeFormData[key])
                this.multiPicklistMapper[key] = this.multiPicklistMapper[key].filter(e => e.value_id != option.value_id);
                this.completeFormData[key] = this.completeFormData[key].filter(e => e != option.value_id);
                if(this.completeFormData[key].length == 0){
                    delete this.completeFormData[key];
                }else{
                    this.completeFormData[key] = JSON.stringify(this.completeFormData[key])
                }
                this.formData();
            }
        },
        removeSelectedPicklistOption(value,key,type){
            if(type =='field'){
                this.completeFormData["fields"][key] = this.completeFormData["fields"][key].filter(e => e != value.value_id);
                if(this.completeFormData["fields"][key].length == 0){
                    delete this.completeFormData["fields"][key];
                }
                this.$refs[key][0].value = this.$refs[key][0].value.filter(op=>op.value_id != value.value_id);
            }else{
                this.completeFormData[key] = JSON.parse(this.completeFormData[key])
                this.completeFormData[key] = this.completeFormData[key].filter(e => e != value.value_id);
                if(this.completeFormData[key].length == 0){
                    delete this.completeFormData[key];
                }else{
                    this.completeFormData[key] = JSON.stringify(this.completeFormData[key])
                }
            }
            this.multiPicklistMapper[key] = this.multiPicklistMapper[key].filter(e => e.value_id != value.value_id);
            this.formData();
        },
        makePicklistCheckBoxSelection(option,key){
            if(this.$refs[key] && this.$refs[key].length > 0 && this.$refs[key][0].value != undefined){
                return this.$refs[key][0].value.some((op) => op.value_id == option.value_id);
            }
            return false;
        },
        //---------------------------------------------------------------------------

        //**********Duration and Size custom fields************** */
        toggleDropdown(type) {
            if (type === 'duration') {
                // toggle duration
                this.open = !this.open

                // always close size
                this.sizeOpen = false
                this.sizeCustomOpen = false
            }

            if (type === 'size') {
                // toggle size
                this.sizeOpen = !this.sizeOpen

                // always close duration
                this.open = false
                this.customOpen = false
            }
        },

        closeDurationDropdown() {
            this.open = false;
            this.customOpen = false;
        },

        closeSizeDropdown(){
            this.sizeOpen = false;
            this.sizeCustomOpen = false;
        },

        selectDurationOption(opt) {
            this.appliedLabel = opt.value;
            this.open = false;
            this.customOpen = false;
            let durationValue = {};
            
            durationValue["type"] = opt.value_id;
            this.completeFormData['duration'] = durationValue;
            this.formData();
        },

        selectSizeOption(opt) {
            this.appliedSizeLabel = opt.value
            this.sizeOpen = false
            this.sizeCustomOpen = false;
            let sizeValue = {};
            
            sizeValue["type"] = opt.value_id;
            this.completeFormData['size'] = sizeValue;
            this.formData();
        },

        openCustom(type) {
            if(type == 'duration'){
                this.customOpen = true;
            }else if(type == 'size'){
                this.sizeCustomOpen = true;
            }    
        },

        cancel( type) {
            if(type == 'duration'){
                this.customOpen = false;
            }else if(type == 'size'){
                this.sizeCustomOpen = false;
            }
        },

        apply() {
            const hasMin = this.min !== '';
            const hasMax = this.max !== '';

            if (!hasMin && !hasMax) {
                this.appliedLabel = '';
                delete this.completeFormData['duration'];
                alert(this.$t('Please enter either minimum Duration or maximum Duration'));
                return;
            }

            if (hasMin && hasMax && Number(this.max) < Number(this.min)) {
                this.appliedLabel = '';
                delete this.completeFormData['duration'];
                alert(this.$t('From value cannot be greater than To value'));
                return;
            }

            const minLabel = hasMin ? `${this.min} ${this.unit}` : `0 ${this.unit}`;
            const maxLabel = hasMax ? `${this.max} ${this.unit}` : this.$t('onwards');

            this.appliedLabel = `${minLabel} – ${maxLabel}`;

            this.open = false;
            this.customOpen = false;

            let durationValue = {};
            durationValue["type"] = 'range';
            if(this.min){
                durationValue["from_value"] = parseInt(this.min);
            }    
            if(this.max){
                durationValue["to_value"] = parseInt(this.max);
            }    
            durationValue["unit"] = this.unit;
            this.completeFormData['duration'] = durationValue;
            this.formData();
        },

        applySize() {
            const hasMin = this.sizeMin !== '';
            const hasMax = this.sizeMax !== '';

            if (!hasMin && !hasMax) {
                this.appliedSizeLabel = '';
                delete this.completeFormData['size'];
                alert(this.$t('Please enter either minimum size or maximum size'));
                return;
            }

            if (hasMin && hasMax && Number(this.sizeMax) < Number(this.sizeMin)) {
                this.appliedSizeLabel = '';
                delete this.completeFormData['size'];
                alert(this.$t('From value cannot be greater than To value'));
                return;
            }

            const minLabel = hasMin ? `${this.sizeMin} ${this.sizeUnit}` : `0 ${this.sizeUnit}`;
            const maxLabel = hasMax ? `${this.sizeMax} ${this.sizeUnit}` : this.$t("Onwards");
            
            this.appliedSizeLabel = `${minLabel} – ${maxLabel}`;

            this.sizeOpen = false;
            this.sizeCustomOpen = false;

            let sizeValue = {};
            sizeValue["type"] = 'range';
            if(this.sizeMin){
                sizeValue["from_value"] = parseInt(this.sizeMin)
            }   
            if(this.sizeMax){
                sizeValue["to_value"] = parseInt(this.sizeMax);
            }      
            sizeValue["unit"] = this.sizeUnit;
            this.completeFormData['size'] = sizeValue;
            this.formData();

            // this.$emit('change', {
            //     min: this.min,
            //     max: this.max,
            //     unit: this.unit
            // })
        },

        clearFilter() {
            this.appliedLabel = ''
            this.min = ''
            this.max = ''
            this.unit = this.units[0]
            this.$emit('change', null)
        },

        onDurationChange(val) {
            console.log('Duration Filter:', val)
        },

        onSizeChange(val) {
            console.log('Size Filter:', val)
        },

        //**********end of duration and size custom fields************** */

        //---------------------------------------------------------------------
        picklistSingleSelect(key,value,type,filterInfo){
            if(this.searchContext !== 'query-builder-in-reports' && type == 'default' && ['search_in', 'search_as'].includes(key)){
                // Replace the mapper because defaults may have been assigned non-reactively.
                this.singlePicklistMapper = Object.assign({}, this.singlePicklistMapper, {[key]: value});
                if(filterInfo.default_value && value.value_id === filterInfo.default_value.value_id){
                    delete this.completeFormData[key];
                }else{
                    this.completeFormData[key] = key === 'search_in' ? JSON.stringify([value.value_id]) : value.value_id;
                }
                if(!this.getSearchKeyword().trim().length){
                    this.saveFilterPreferences();
                    return;
                }
                this.formData();
                return;
            }
            if(type == 'default'){
                if(filterInfo.dependent_on_keyword){
                    if((this.$route.query && Object.keys(this.$route.query).includes("keyword") && this.$route.query.keyword.length) || document.querySelector("#gloabl_search_in_file_browse") && document.querySelector("#gloabl_search_in_file_browse").value){
                            if(value.value_id == filterInfo.default_value.value_id){
                                this.$set(this.singlePicklistMapper, key, filterInfo.default_value);
                                this.$refs[key][0].value = filterInfo.default_value;
                                delete this.completeFormData[key];
                                this.$forceUpdate();
                            }else{
                                if(key == 'search_in'){
                                    this.completeFormData[key] = JSON.stringify([value.value_id]);
                                }else{
                                    this.completeFormData[key] = value.value_id;
                                }
                                this.$set(this.singlePicklistMapper, key, value);
                                this.$refs[key][0].value = value;
                                this.$forceUpdate();
                            }
                    }else if(value.value_id == filterInfo.default_value.value_id){
                        return;
                    }else{
                        alert("This filter cannot be applied if keyword search is empty");
                        this.$set(this.singlePicklistMapper, key, filterInfo.default_value);
                        this.$refs[key][0].value = filterInfo.default_value;
                        delete this.completeFormData[key];
                        this.$forceUpdate();
                    }
                }else{
                    this.completeFormData[key] = value.value_id;
                }
            }else if(type =='field'){
                this.completeFormData['fields'][key] = value.value_id;
                this.$refs[key][0].value = value;
            }
            this.formData();
        },
        //Users-------------------------------------------------------------------
        updatedUsersList(option,key){
            if(!this.completeFormData[key]){
                this.completeFormData[key] = [];
            }else{
                this.completeFormData[key] = JSON.parse(this.completeFormData[key])
            }
            this.completeFormData[key].push(option);
            this.completeFormData[key] = JSON.stringify(this.completeFormData[key])
            this.formData();
        },
        removedUserFromList(option,key){
            this.completeFormData[key] = JSON.parse(this.completeFormData[key])
            this.completeFormData[key] = this.completeFormData[key].filter(e => e != option);
            if(this.completeFormData[key].length == 0){
                delete this.completeFormData[key];
            }else{
                this.completeFormData[key] = JSON.stringify(this.completeFormData[key])
            }
            this.formData();
        },
        //----------------------------------------------------------
        //Tags--------------------------------------------------------
        bulkTagsFindCollectionOnSelect(bulkTagIds,key){
            this.updatedTagsList = bulkTagIds;
            this.completeFormData[key] = JSON.stringify(this.updatedTagsList);
            this.formData();
        },
        tagsFindCollectionOnSelect(option,key){
            if(!this.updatedTagsList.includes(option._id)){
                this.updatedTagsList.push(option._id);
            }
            this.completeFormData[key] = JSON.stringify(this.updatedTagsList);
            this.formData();
        },
        tagsFindCollectionOnRemove(option, key){
            this.completeFormData[key] = JSON.parse(this.completeFormData[key])
            this.completeFormData[key] = this.completeFormData[key].filter(e => e != option._id);
            this.updatedTagsList = this.completeFormData[key];
            if(this.completeFormData[key].length == 0){
                delete this.completeFormData[key];
            }else{
                this.completeFormData[key] = JSON.stringify(this.completeFormData[key])
            }
            this.formData();
        },
        //--------------------------------------------------------------
        //Labels--------------------------------------------------------
        labelsFindCollectionOnSelect(option,key){
            if(!this.updatedLabelsList.includes(option._id)){
                this.updatedLabelsList.push(option._id);
            }
            this.completeFormData[key] = JSON.stringify(this.updatedLabelsList);
            this.formData();
        },
        labelsFindCollectionOnRemove(option, key){
            this.completeFormData[key] = JSON.parse(this.completeFormData[key])
            this.completeFormData[key] = this.completeFormData[key].filter(e => e != option._id);
            this.updatedLabelsList = this.completeFormData[key];
            if(this.completeFormData[key].length == 0){
                delete this.completeFormData[key];
            }else{
                this.completeFormData[key] = JSON.stringify(this.completeFormData[key])
            }
            this.formData();
        },
        //--------------------------------------------------------------
        //Catalogs------------------------------------------------------
        updatedCatalogsListComp(option,key){
            this.updatedFilteredCatalogsList.push(option._id);
            this.completeFormData[key] = JSON.stringify(this.updatedFilteredCatalogsList);
            this.formData();
        },
        removedCatalogFromList(option, key){
            this.completeFormData[key] = JSON.parse(this.completeFormData[key])
            this.completeFormData[key] = this.completeFormData[key].filter(e => e != option._id);
            this.updatedFilteredCatalogsList = this.completeFormData[key];
            if(this.completeFormData[key].length == 0){
                delete this.completeFormData[key];
            }else{
                this.completeFormData[key] = JSON.stringify(this.completeFormData[key])
            }
            this.formData();
        },
        updatedCatalogsList(option,key){
            this.completeFormData[key] = option._id;
            this.formData();
        },
        //Date----------------------------------------------------------------------------------------------
        updateDateValue(type,value,key, filterType){
            let fVal = value[0];
            let tVal = value[1];
            if(!fVal || !tVal){
                alert("Please select date range");
                return false;
            }
            if(filterType == 'DATE_TIME'){
                fVal = fVal.replace(" ","T");
                tVal = tVal.replace(" ", "T");
            }
            let temp = {'from_value':fVal,'to_value':tVal};
            if(type == 'field'){
                this.completeFormData['fields'][key] = temp;
            }else{
                this.completeFormData[key] = temp;
            }
        },
        //---------------------------------------------------------------------------------------------------
        //Integer--------------------------------------------------------------------------------------------
        customiseIntegerPostDataBasedOnType(type,value,key){
            let temp = null;
            this.integerMapper[key] = value;
            if(value.includes('-')){
                temp = value.split("-");
                temp = {'from_value':parseInt(temp[0]),'to_value':parseInt(temp[1])};
            }else{
                temp = parseFloat(value)
            }
            if(type == 'field'){
                this.completeFormData['fields'][key] = temp;
                if(isNaN(this.completeFormData['fields'][key]) || this.completeFormData['fields'][key].length == 0){
                    delete this.completeFormData['fields'][key];
                }
            }else{
                this.completeFormData[key] = temp;
                if(isNaN(this.completeFormData[key]) || this.completeFormData[key].length == 0){
                    delete this.completeFormData[key];
                }
            }
        },
        filterLabelCallback(){
            return `${'More' +" + "}`
        },

        enableDisableSearchWithFilter(newVal){
            if(!this.barcodeInfoFromStartup.enable_nlp_search)return;
            let gIndex = this.globalFilters.findIndex(e => e.key == 'search_as');
            let uIndex = this.userFilters.findIndex(e => e.key == 'search_as');
            if(newVal){
                this.combinedFilters = this.combinedFilters.filter(e => e.key != 'search_as');
            }else{
                if(gIndex > -1){
                    this.combinedFilters.push(this.globalFilters[gIndex])
                }
                if(uIndex > -1){
                    this.combinedFilters.push(this.userFilters[uIndex])
                }
            }
        },

        getfiltersListOnContext(fromReloadPanel = false){
                // let payload = {};
                // let context = String(workspaceCntx).toLowerCase()
                // if(context == 'bins'){
                //     payload = {name:"bin_workspace"}
                // }else if(context == 'catalogs-display'){
                //     payload = {name:"catalog_workspace"}
                // }else if(context == 'ticket-display'){
                //     let screenType = "Ticket"
                //     if(this.getLoggedInUserType() == 'Client'){
                //         screenType = "Customer Ticket"
                //     }
                //     payload = {name:'pam', params:{'screen_type':screenType}}
                // }else if(this.$route.name == 'board-projects'){
                //     payload = {name:'pam', params:{'screen_type':'Task/Issue'}}
                // }else if(this.$route.name == 'tasks-projects'){
                //     payload = {name:'pam', params:{'screen_type':'Task/Issue'}}
                // }else if(this.$route.name == 'issues-projects'){
                //     payload = {name:'pam', params:{'screen_type':'Task/Issue'}}
                // }
                let data = this.getAdvancedSearchDataFromStore()
                this.filtersList = data.filters;
                this.globalFiltersDropdown = data.filters;
                this.userFiltersDropdown = data.filters;
                this.pinnedFilter = data.pinned_filters;
                if(data.global_filters){
                    this.$set(this, 'globalFilters', data.global_filters);
                    this.$set(this, 'selectedGlobalConfigFiltersList', data.global_filters);
                }else{
                    this.globalFilters = [];
                    this.selectedGlobalConfigFiltersList = [];
                }
                if(data.user_filters){
                    this.userFilters = data.user_filters;
                    this.selectedUserConfigFiltersList = data.user_filters;
                }else{
                    this.userFilters = [];
                    this.selectedUserConfigFiltersList = [];
                }
                this.combinedFilters = this.globalFilters.concat(this.userFilters);
                if(this.isNLPSearchMode){
                    this.enableDisableSearchWithFilter(this.isNLPSearchMode)
                }
                if(this.promiseFiltersList && this.promiseFiltersList.combinedFiltersListOnResolve)this.promiseFiltersList.combinedFiltersListOnResolve.resolve(this.combinedFilters);
                this.reloadAdvanceSearchFilters(fromReloadPanel);
                if(this.searchContext !== 'query-builder-in-reports')this.restoreFilterPreferences();
        },
        updatePrimayCreatedOnFilterValue(key,value,type,filterType=null){
            if(filterType && filterType == 'year'){
                let fVal = value[0];
                let tVal = value[1];
                this.completeFormData[key] = {"type":type,'from_value':fVal+'-01-01','to_value':tVal+'-12-31'};
            }else{
                let fVal = value[0];
                let tVal = value[1];
                this.completeFormData[key] = {"type":type,'from_value':fVal,'to_value':tVal};
            }
            this.formData();
        },
        updatePrimayCreatedOnSingleSelectFilterValue(key,value,type){
            switch(type) {
                case 'on_date':
                    this.completeFormData[key] = {'type':'on_date','value':value};
                    break;
                case 'before_date':
                    this.completeFormData[key] = {'type':'before_date','to_value':value};
                    break;
                case 'after_date':
                    this.completeFormData[key] = {'type':'after_date','from_value':value};
                    break;
            }
            this.formData();
        },
        updateCreatedOnFilter(key,value){
            if(this.searchContext !== 'query-builder-in-reports' && key === 'created_on'){
                this.selectedCreatedDateValue = value;
                this.createdDateCustomFilterValSingleVal = null;
                this.createdDateCustomFilterVal = null;
                this.createdDateCustomFilterValForYearRange = null;
            }
            if(key == 'created_on'){
                switch(value.value_id) {
                    case 'today_date':
                        this.completeFormData[key] =  {"type":"today_date"};
                        break;
                    case 'yesterday_date':
                        this.completeFormData[key] =  {"type":"yesterday_date"};
                        break;
                    case 'last_week':
                        this.completeFormData[key] =  {"type":"last_week"};
                        break;
                    case 'last_one_hr':
                        this.completeFormData[key] =  {"type":"last_one_hr"};
                        break;
                    case 'on_date':
                    case 'before_date':
                    case 'after_date':
                        setTimeout(() => {
                            if(this.$refs["createdOnSingle"])this.$refs["createdOnSingle"][0].focus();
                        }, 600);
                        break;
                    case 'range':
                        setTimeout(() => {
                            if(this.$refs["createdOnRange"])this.$refs["createdOnRange"][0].focus();
                        }, 600);
                        break;
                    case 'year_range':
                        setTimeout(() => {
                            if(this.$refs["createdOnYearRange"])this.$refs["createdOnYearRange"][0].focus();
                        }, 600);
                        break;
                    default:
                        if(this.searchContext !== 'query-builder-in-reports'){
                            const preference = {
                                created_on: {type: value.value_id},
                                createdOnOption: value.value_id
                            };
                            if(this.validateFilterPreferences(preference)){
                                this.completeFormData[key] = preference.created_on;
                            }
                        }
                        break;
                }
            }else{
                this.completeFormData[key] = value.key;
            }
            if(this.searchContext !== 'query-builder-in-reports' && key === 'created_on' &&
                ['on_date', 'before_date', 'after_date', 'range', 'year_range'].includes(value.value_id)){
                delete this.completeFormData.created_on;
                this.saveFilterPreferences();
                return;
            }
            this.$nextTick(() =>{
                this.formData();
            })
        },
        updatePrimayFilterValueSearchAs(key,value){
            this.selectedFindWithValue = value;
            if(value.key == "any"){
                delete this.completeFormData['search_as'];
            }else{
                    if(this.searchContext !== 'query-builder-in-reports' || (this.$route.query && Object.keys(this.$route.query).includes("keyword") && this.$route.query.keyword.length) ||
                        (this.compType && ["subComp"].includes(this.compType) && document.getElementById("gloabl_search_in_file_browse") && document.getElementById("gloabl_search_in_file_browse").value.length)){
                        this.completeFormData[key] = value.key;
                    }else if(!this.checkIfNotAdvancedSearch && this.$parent && this.$parent.$refs && this.$parent.$refs.query_keyword && this.$parent.$refs.query_keyword.value && this.$parent.$refs.query_keyword.value.trim().length){
                        this.completeFormData[key] = value.key;
                    }else{
                        alert("This filter cannot be applied if keyword search is empty");
                        setTimeout(() => {
                            this.selectedFindWithValue = {"label":"Any word","key":"any"};
                        }, 200);
                        return
                    }
            }
            if(this.searchContext !== 'query-builder-in-reports' && !this.getSearchKeyword().trim().length){
                this.saveFilterPreferences();
                return;
            }
            this.formData();
            
        },
        updatePrimayFilterValueSearchIn(key,value){
            this.selectedFindInValue = value;
            if(value.key == "any"){
                delete this.completeFormData['search_in'];
            }else{
                    if(this.searchContext !== 'query-builder-in-reports' || (this.$route.query && Object.keys(this.$route.query).includes("keyword") && this.$route.query.keyword.length)
                        || (this.compType && ["subComp"].includes(this.compType)  && document.getElementById("gloabl_search_in_file_browse") && document.getElementById("gloabl_search_in_file_browse").value.length)){
                            this.completeFormData[key] = JSON.stringify([value.key]);
                    }else if(!this.checkIfNotAdvancedSearch && this.$parent && this.$parent.$refs && this.$parent.$refs.query_keyword && this.$parent.$refs.query_keyword.value && this.$parent.$refs.query_keyword.value.trim().length){
                        this.completeFormData[key] =JSON.stringify([value.key]);
                    }else{
                        alert("This filter cannot be applied if keyword search is empty");
                        setTimeout(() => {
                            this.selectedFindInValue = {"label":"Any","key":"any"};  
                        }, 200);
                        return
                    }
            }
            if(this.searchContext !== 'query-builder-in-reports' && !this.getSearchKeyword().trim().length){
                this.saveFilterPreferences();
                return;
            }
            this.formData();
        },
        fetchGlobalFiltersSearchData(){
            let tempForm = {}
            for(let eachFilter of this.globalFilters){
                if(eachFilter.key == "created_on" && this.selectedCreatedDateValue &&
                   "value_id" in this.selectedCreatedDateValue){
                    tempForm[eachFilter.key] = {type:this.selectedCreatedDateValue["value_id"]}
                    if(["before_date"].includes(tempForm[eachFilter.key].type)){
                        tempForm[eachFilter.key]["to_value"] = this.createdDateCustomFilterValSingleVal
                    }else if(["on_date"].includes(tempForm[eachFilter.key].type)){
                        tempForm[eachFilter.key]["value"] = this.createdDateCustomFilterValSingleVal
                    }else if(["after_date"].includes(tempForm[eachFilter.key].type)){
                        tempForm[eachFilter.key]["from_value"] = this.createdDateCustomFilterValSingleVal
                    }else if(["range"].includes(tempForm[eachFilter.key].type) && this.createdDateCustomFilterVal){
                        tempForm[eachFilter.key]["from_value"] = this.createdDateCustomFilterVal[0]
                        tempForm[eachFilter.key]["to_value"] = this.createdDateCustomFilterVal[1]
                    }else if(["year_range"].includes(tempForm[eachFilter.key].type) && this.createdDateCustomFilterValForYearRange){
                        tempForm[eachFilter.key]["from_value"] = this.createdDateCustomFilterValForYearRange[0]+'-01-01'
                        tempForm[eachFilter.key]["to_value"] = this.createdDateCustomFilterValForYearRange[1]+'-12-31'
                    }
                }
                // else if(eachFilter.key == "mime_type" && this.selectedMimeTypeValue &&
                //     this.selectedMimeTypeValue.length){
                //     let mimeList = []
                //     for(let eachMime of this.selectedMimeTypeValue){
                //         if(!mimeList.includes(eachMime.value_id)){
                //             mimeList.push(eachMime.value_id)
                //         }
                //     }
                //     if(mimeList.length){
                //         tempForm[eachFilter.key] = JSON.stringify(mimeList)
                //     }
                // }
            }
            // if(this.selectedFindInValue && 'key' in this.selectedFindInValue && this.selectedFindInValue.key != "any"){
            //     tempForm['search_in'] = `["${this.selectedFindInValue.key}"]`
            // }
            // if(this.selectedFindWithValue && 'key' in this.selectedFindWithValue && this.selectedFindWithValue.key != "any"){
            //     tempForm['search_as'] = `${this.selectedFindWithValue.key}`
            // }
            return tempForm
        },
        getSearchKeyword(){
            const keyword = this.$route.query.keyword || '';
            return typeof keyword === 'string' ? keyword : '';
        },
        getSearchRequestFilters(filters, keyword){
            if(this.searchContext === 'query-builder-in-reports')return filters;
            if(keyword === undefined){
                keyword = this.getSearchKeyword();
            }
            const payload = Object.assign({}, filters);
            // A custom date is only a request filter after its required inputs exist.
            // Do not apply the stricter storage schema to existing server filter payloads.
            if(payload.created_on){
                const required = {
                    on_date: ['value'], before_date: ['to_value'], after_date: ['from_value'],
                    range: ['from_value', 'to_value'], year_range: ['from_value', 'to_value']
                }[payload.created_on.type];
                if(required && required.some(key => !payload.created_on[key]))delete payload.created_on;
            }
            if(typeof keyword !== 'string' || !keyword.trim().length){
                delete payload.search_in;
                delete payload.search_as;
            }
            return payload;
        },
        formData(forceEmit = false){
            let tempForm = this.completeFormData;
            for(let eachGF of Object.keys(this.fetchGlobalFiltersSearchData())){
                tempForm[eachGF] = this.fetchGlobalFiltersSearchData()[eachGF]
            }
            if(this.searchContext !== 'query-builder-in-reports')this.saveFilterPreferences();
            this.$emit("advancedSearchData",this.getSearchRequestFilters(tempForm));
            if(!forceEmit)this.reloadRouteFilters();
        },
        validatedSearchQuery(){
            this.$refs["addOrEditFav"].validatedQuery(this.returnFormData(true))
        },
        returnFormData(includeKeyword = false, keyword){
            if(includeKeyword){
                let searchQuery = {}
                let routeQuery = this.$route.query
                let keywordFilter = ""
                if(routeQuery && 'keyword' in routeQuery){
                    keywordFilter = routeQuery.keyword
                }
                if (keywordFilter.trim().length){
                    searchQuery["keyword"] = keywordFilter
                }
                let tempFilters = this.completeFormData
                for(let eachGF of Object.keys(this.fetchGlobalFiltersSearchData())){
                    tempFilters[eachGF] = this.fetchGlobalFiltersSearchData()[eachGF]
                }
                // Saving must retain dropdown choices even without a keyword.
                // Request-only filtering remains in formData/returnFormData(false).
                searchQuery["advanceFilter"] = this.searchContext === 'query-builder-in-reports'
                    ? this.getSearchRequestFilters(tempFilters, keywordFilter)
                    : JSON.parse(JSON.stringify(tempFilters));
                if(this.searchContext !== 'query-builder-in-reports'){
                    // Save the displayed choices, even when the request payload omits them.
                    for(const key of ['search_in', 'search_as']){
                        const selected = this.singlePicklistMapper[key];
                        if(!selected || typeof selected.value_id !== 'string')continue;
                        const filter = this.combinedFilters.concat(this.filtersList || [])
                            .find(item => item.key === key);
                        if(!filter || !Array.isArray(filter.values) ||
                            !filter.values.some(option => option.value_id === selected.value_id))continue;
                        searchQuery.advanceFilter[key] = key === 'search_in'
                            ? JSON.stringify([selected.value_id]) : selected.value_id;
                    }
                }
                if(Object.keys(searchQuery).length){
                    return searchQuery
                }else{
                    alert("Default query is not allowed to save.")
                    return null
                }
            }
            // Keyword-submit callers can pass the exact keyword being submitted.
            // Keep the existing live-input fallback for callers using the old signature.
            if(keyword === undefined){
                const input = document.getElementById('gloabl_search_in_file_browse');
                keyword = input ? input.value : this.getSearchKeyword();
            }
            return this.getSearchRequestFilters(this.completeFormData, keyword);
        },
        resetFields(forceReset = false){
            this.selectedFiltersList = [];
            this.updatedTagsList = [];
            this.updatedLabelsList = [];
            this.updatedFilteredCatalogsList = [];  
            this.completeFormData = {'fields':{}};
            this.dateMappper = {};
            this.selectedFindWithValue = {"label":"Any word","key":"any"};
            this.selectedFindInValue = {"label":"Any","key":"any"};
            this.selectedMimeTypeValue = [];
            this.selectedCreatedDateValue = {};
            this.multiPicklistMapper = {};
            this.usersFilterMapper = {};
            this.singlePicklistMapper = {};
            this.integerMapper = {};
            this.dateMappper = {};
            if(this.searchContext !== 'query-builder-in-reports'){
                this.createdDateCustomFilterValSingleVal = null;
                this.createdDateCustomFilterVal = null;
                this.createdDateCustomFilterValForYearRange = null;
                for(const filter of this.combinedFilters){
                    if(['search_in', 'search_as'].includes(filter.key) && filter.default_value){
                        this.$set(this.singlePicklistMapper, filter.key, filter.default_value);
                    }
                }
                this.restoredFilterPreferencesKey = this.filterPreferencesKey();
                this.clearFilterPreferences();
            }
            if(!forceReset){
                this.formData();
            }
        },
        //-------------------------Global Filters ---------------------------
        selectGlobalFilter(option){
            let index = this.globalFiltersDropdown.findIndex(item => item.key == option.key);
            if(index > -1){
                this.globalFiltersDropdown[index].checked = true;
                this.updateSelectedGlobalFilter('filter','add',option);
            }
        },
        removeSelectedGlobalFilter(option){
            if(confirm('Are you sure you want to remove selected filter from global filters?')){
                this.selectedGlobalConfigFiltersList = this.selectedGlobalConfigFiltersList.filter(e => e.key != option.key);
                this.updateSelectedGlobalFilter('filter','remove',option);
            }
        },
        makeGlobalFiltersCheckboxAction(option){
            return this.selectedGlobalConfigFiltersList.some((op) => op.key === option.key);
        },
        updateSelectedGlobalFilter(type,method,option){
            let context = String(this.searchContext).toLowerCase();
            let payload = {};
            if(type == 'filter'){
                if(method == 'add'){
                    payload = {'added_global_filters':[option]}
                }else if(method == 'remove'){
                    payload = {'removed_global_filters':[option]}
                }
            }
            if(context == 'bins'){
                payload['name'] = "bin_workspace";
            }else if(context == 'catalogs-display'){
                payload['name'] = "catalog_workspace";
            }
            this.updateGlobalFilters(payload).then((data) => {
                if (data.statusCode == 200) {
                    this.$toast.success(data.message);
                } else {
                    this.$toast.error(data.message);
                }
            })
        },
        //--------------------------Global Filters end ----------------------------
        
        //-------------------------User Filters ---------------------------
        selectUserFilter(option){
            let index = this.userFiltersDropdown.findIndex(item => item.key == option.key);
            if(index > -1){
                this.userFiltersDropdown[index].checked = true;
                this.updateSelectedUserFilter('filter','add',option);
            }
        },
        removeSelectedUserFilter(option){
            if(confirm('Are you sure you want to remove selected filter from user filters?')){
                this.selectedUserConfigFiltersList = this.selectedUserConfigFiltersList.filter(e => e.key != option.key);
                // let index = this.userFiltersDropdown.findIndex(item => item.key == option.key);
                // if(index > -1){
                //     this.userFiltersDropdown[index].checked = false;
                    this.updateSelectedUserFilter('filter','remove',option);
                // }
            }
        },
        makeUserFiltersCheckboxAction(option){
            return this.selectedUserConfigFiltersList.some((op) => op.key === option.key);
        },
        updateSelectedUserFilter(type,method,option){
            let context = String(this.searchContext).toLowerCase();
            let payload = {};
            if(type == 'filter'){
                if(method == 'add'){
                    payload = {'added_user_filters':[option]}
                }else if(method == 'remove'){
                    payload = {'removed_user_filters':[option]}
                }
            }else{
                this.pinnedFilter = !this.pinnedFilter;
                payload = {'pinned_filters':this.pinnedFilter}
            }
            if(context == 'bins'){
                payload['name'] = "bin_workspace";
            }else if(context == 'catalogs-display'){
                payload['name'] = "catalog_workspace";
            }
            this.updateUserFilters(payload).then((data) => {
                if (data.statusCode == 200) {
                    this.$toast.success(data.message);
                } else {
                    this.$toast.error(data.message);
                }
            })
        },
        //--------------------------User Filters end ----------------------------
        
        
        removeSelectedFilter(option,doNotCallGet=false){
            let tempKey = option.key;
            this.selectedFiltersList = this.selectedFiltersList.filter(e => e.key != option.key);
            this.emptyTheFields(tempKey);
            if(option.key == 'duration'){
                this.appliedLabel = '';
                this.min = '';
                this.max = '';
                this.unit = 'Sec';
            }
            if(option.key == 'size'){
                this.appliedSizeLabel = '';
                this.sizeMin = '';
                this.sizeMax = '';
                this.sizeUnit = 'KB';
            }
            if(option.filter_type == 'field'){
                delete this.completeFormData["fields"][tempKey];
            }else{
                delete this.completeFormData[tempKey];
            }
            this.$nextTick(() => {
                if(!Object.keys(this.completeFormData).includes("fields")){
                    this.completeFormData['fields'] = {};
                }
            })
            if(!doNotCallGet)this.formData();
        },
        removeSelectedClass(){
            document.getElementsByClassName('focusTheField').forEach(el => el.classList.remove("focusTheField"))
        },
        emptyTheFields(tempKey){
            if(this.multiPicklistMapper[tempKey] && this.multiPicklistMapper[tempKey].length){
                this.multiPicklistMapper[tempKey] = []
            }else if(this.singlePicklistMapper[tempKey] && Object.keys(this.singlePicklistMapper[tempKey]).length){
                this.singlePicklistMapper[tempKey] = '';
            }else if(this.integerMapper[tempKey]){
                this.integerMapper[tempKey] = null
            }else if(this.dateMappper[tempKey]){
                this.dateMappper[tempKey] = null;
            }else if(this.completeFormData["fields"][tempKey]){
                this.completeFormData["fields"][tempKey] = '';
            }else if(tempKey == 'tag_id'){
                this.updatedTagsList = [];
            }else if(tempKey == 'catalog_id'){
                this.updatedFilteredCatalogsList = [];
            }else if(tempKey == 'label_id'){
                this.updatedLabelsList = [];
            }else if(this.usersFilterMapper[tempKey] && this.usersFilterMapper[tempKey].length){
                this.usersFilterMapper[tempKey] = [];
            }
        },
        openSearchFilters(ref){
            this.$refs[ref].$el.focus();
        },
        updateFieldLength(value){
            if(value != undefined){
                if(value > 2){
                    this.fieldLength = (value.length + 1)*8;
                }else{
                    this.fieldLength = (value.length + 4)*8;
                }
            }
        },
        closeReloadPanel(){
            this.openReloadPanel = false;
        },
        reloadButtonClicked(){
            let payload = {};
            payload = {name:"catalog_workspace"}
            this.getConfiguredSearchActionsFromServer(payload).then((data)=>{
                this.setAdvancedSearchDataToStore(data);
                this.$nextTick(() => {
                    this.getfiltersListOnContext(true);
                    this.openReloadPanel = false;
                })
            })
        },
        checkIfValueAvailable(key){
            if(this.completeFormData['fields'] && Object.keys(this.completeFormData['fields']).includes(key) && this.completeFormData['fields'][key].length > 0){
                return true;
            }else if(this.completeFormData && Object.keys(this.completeFormData).includes(key) && this.completeFormData[key].length > 0){
                return true;
            }
            return false;
        },
        handleFieldsNotificaionInAdvancedSearch(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let field_info = notification.message;
                    if (notification.message_type == NotifierConstants.fieldCreatedNotification){
                        field_info['key'] = field_info._id;
                        field_info['filter_type'] = 'field';
                        this.filtersList.push(field_info);
                        this.setAdvancedSearchDataToStore({'filters':this.filtersList})
                        this.globalFiltersDropdown.push(field_info); 
                        this.userFiltersDropdown.push(field_info);
                    }
                    if(notification.message_type == NotifierConstants.fieldModifiedNotification){
                        let field = this.filtersList.filter((e_)=>e_.key == field_info._id);
                        if (field.length != 0){
                            field = field[0]
                            Object.assign(field, field_info)
                        }
                        let globalFieldsDropdown = this.selectedUserConfigFiltersList.filter((e_)=>e_.key == field_info._id);
                        if (globalFieldsDropdown.length != 0){
                            globalFieldsDropdown = globalFieldsDropdown[0]
                            Object.assign(globalFieldsDropdown, field_info)
                        }
                        let userFieldsDropdown = this.selectedUserConfigFiltersList.filter((e_)=>e_.key == field_info._id);
                        if (userFieldsDropdown.length != 0){
                            userFieldsDropdown = userFieldsDropdown[0]
                            Object.assign(userFieldsDropdown, field_info)
                        }
                        let defaultConfiguredFilters = this.combinedFilters.filter((e_)=>e_.key == field_info._id);
                        if (defaultConfiguredFilters.length != 0){
                            defaultConfiguredFilters = defaultConfiguredFilters[0]
                            Object.assign(defaultConfiguredFilters, field_info)
                        }
                    }
                    if(notification.message_type == NotifierConstants.fieldRemovedNotification){
                        this.filtersList = this.filtersList.filter((e_)=>e_.key != field_info._id);
                        // this.selectedGlobalConfigFiltersList = this.selectedGlobalConfigFiltersList.filter((e_)=>e_.key != field_info._id);
                        // this.selectedUserConfigFiltersList = this.selectedUserConfigFiltersList.filter((e_)=>e_.key != field_info._id);
                        // this.setAdvancedSearchDataToStore({'global_filters':this.selectedGlobalConfigFiltersList})
                        // this.setAdvancedSearchDataToStore({'user_filters':this.selectedUserConfigFiltersList})
                        let selectedFieldsIndex = this.selectedFiltersList.findIndex(item => item.key == field_info._id);
                             field_info['key'] = field_info._id;
                             field_info['filter_type'] = 'field';
                            if(selectedFieldsIndex > -1){
                                    // this.$toast.error("Selected " + field_info.name+ " is deleted by other user")
                                    // this.removeSelectedFilter(field_info,true);
                                    this.reloadPanelMessage = 'The selected field has been deleted. Please click the reload button to update.'
                                    this.openReloadPanel = true;
                            }
                        let combinedDefaultFiltersIndex = this.combinedFilters.findIndex(item => item.key == field_info._id);
                             field_info['key'] = field_info._id;
                             field_info['filter_type'] = 'field';
                            if(combinedDefaultFiltersIndex > -1){
                                    // this.$toast.error("Selected " + field_info.name + " is deleted by other user")
                                    // this.combinedFilters = this.combinedFilters.filter(e => e.key != field_info.key);
                                    // this.emptyTheFields(field_info)
                                    // if(field_info.filter_type == 'field'){
                                    //     delete this.completeFormData["fields"][field_info];
                                    // }else{
                                    //     delete this.completeFormData[field_info];
                                    // }
                                    // this.$nextTick(() => {
                                    //     if(!Object.keys(this.completeFormData).includes("fields")){
                                    //         this.completeFormData['fields'] = {};
                                    //     }
                                    // })
                                    this.reloadPanelMessage = 'The selected field has been deleted. Please click the reload button to update.'
                                    this.openReloadPanel = true;
                            }
                    }
            }
        },
        handleFilterUpdatedNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let filter_info = notification.message;
                if (notification.message_type == NotifierConstants.globalSearchFilterUpdated){
                    if(filter_info.user_id && (this.getLoggedInUserId() == filter_info.user_id)){
                        if(filter_info.added_global_filters){
                            this.globalFiltersDropdown = this.globalFiltersDropdown.filter(e => e.key != filter_info.added_global_filters[0].key)   
                            this.userFiltersDropdown = this.userFiltersDropdown.filter(e => e.key != filter_info.added_global_filters[0].key)   
                            this.filtersList = this.filtersList.filter(e => e.key != filter_info.added_global_filters[0].key)
                        }
                        if(filter_info.removed_global_filters){
                            this.globalFiltersDropdown.push(filter_info.removed_global_filters[0])   
                            this.userFiltersDropdown.push(filter_info.removed_global_filters[0])  
                        }
                        if(filter_info.global_filters){
                            this.globalFilters = filter_info.global_filters;
                            this.selectedGlobalConfigFiltersList = filter_info.global_filters;
                            this.setAdvancedSearchDataToStore({'global_filters':this.globalFilters})
                        }
                        this.combinedFilters = this.globalFilters.concat(this.userFilters);
                        this.setAdvancedSearchDataToStore({'filters':this.filtersList});
                    }else{
                        this.reloadPanelMessage = 'Global filters configuration updated. Please click the reload button to update.'
                        this.openReloadPanel = true; 
                    }
                }
                if(notification.message_type == NotifierConstants.userFilterSearchUpdated){
                    if(filter_info.user_id && (this.getLoggedInUserId() == filter_info.user_id)){
                        if(filter_info.added_user_filters){
                            this.userFiltersDropdown = this.userFiltersDropdown.filter(e => e.key != filter_info.added_user_filters[0].key)   
                            this.globalFiltersDropdown = this.globalFiltersDropdown.filter(e => e.key != filter_info.added_user_filters[0].key)   
                            this.filtersList = this.filtersList.filter(e => e.key != filter_info.added_user_filters[0].key);
                        }
                        if(filter_info.removed_user_filters){
                            this.userFiltersDropdown.push(filter_info.removed_user_filters[0]) 
                            if(filter_info.removed_global_filters){
                                this.globalFiltersDropdown.push(filter_info.removed_global_filters[0])   
                            }
                        }
                        if(filter_info.user_filters){
                            this.userFilters = filter_info.user_filters;
                            this.setAdvancedSearchDataToStore({'user_filters':this.userFilters})
                        }
                        this.combinedFilters = this.globalFilters.concat(this.userFilters);
                        this.setAdvancedSearchDataToStore({'filters':this.filtersList})

                        if(Object.keys(filter_info).includes('pinned_filters')){
                            this.updatestartupDatainfo({"pinned_filters_in_catalog_workspace":filter_info.pinned_filters});
                            this.setAdvancedSearchDataToStore({'pinned_filters':filter_info.pinned_filters})
                        }
                    }
                }
            }
        },
        registerforWebsocketNotifications(){
            this.addWSEventListener({
                    eventname:[NotifierConstants.fieldCreatedNotification, NotifierConstants.fieldModifiedNotification, NotifierConstants.fieldRemovedNotification],
                    callback:this.handleFieldsNotificaionInAdvancedSearch,
                    parent:"AdvancedSearch"})
            this.addWSEventListener({
                    eventname:[NotifierConstants.globalSearchFilterUpdated, NotifierConstants.userFilterSearchUpdated],
                    callback:this.handleFilterUpdatedNotification,
                    parent:"AdvancedSearch"})
            },
        unRegisterforWebsocketNotifications(){
            this.removeWSEventListener({
                    eventname:[NotifierConstants.fieldCreatedNotification, NotifierConstants.fieldModifiedNotification, NotifierConstants.fieldRemovedNotification],
                    callback:this.handleFieldsNotificaionInAdvancedSearch,
                    parent:"AdvancedSearch"})
            this.removeWSEventListener({
                    eventname:[NotifierConstants.globalSearchFilterUpdated, NotifierConstants.userFilterSearchUpdated],
                    callback:this.handleFilterUpdatedNotification,
                    parent:"AdvancedSearch"})
            },
        reloadRouteFilters(){
            this.promiseFiltersList = {'combinedFiltersListOnResolve': []};
                this.tempFiltersList = new Promise((resolve, reject) =>{
                    this.promiseFiltersList.combinedFiltersListOnResolve = {resolve: resolve, reject: reject};
                });
                if(this.tempFiltersList){
                    this.tempFiltersList.then((data) => {
                        this.combinedFilters = data;
                        this.$nextTick(() => {
                            if(this.singlePicklistMapper['search_in'] && Object.keys(this.singlePicklistMapper['search_in']).length > 0){
                                if(!this.singlePicklistMapper['search_as'] || Object.keys(this.singlePicklistMapper['search_as']).length == 0){
                                    for(let i = 0 ; i < this.combinedFilters.length; i++){
                                        if(this.combinedFilters[i].key == 'search_as'){
                                            this.singlePicklistMapper['search_as'] = this.combinedFilters[i].default_value;
                                            if(this.$refs['search_as'] && this.$refs['search_as'][0])this.$refs['search_as'][0].value = this.combinedFilters[i].default_value;
                                        }
                                    }
                                }
                                return;
                            }
                            if(this.singlePicklistMapper['search_as'] && Object.keys(this.singlePicklistMapper['search_as']).length > 0){
                                if(!this.singlePicklistMapper['search_in'] || Object.keys(this.singlePicklistMapper['search_in']).length == 0){
                                    for(let i = 0 ; i < this.combinedFilters.length; i++){
                                        if(this.combinedFilters[i].key == 'search_in'){
                                            this.singlePicklistMapper['search_in'] = this.combinedFilters[i].default_value;
                                            if(this.$refs['search_in'] && this.$refs['search_as'][0])this.$refs['search_in'][0].value = this.combinedFilters[i].default_value;
                                        }
                                    }
                                }
                                return;
                            }

                            for(let i = 0 ; i < this.combinedFilters.length; i++){
                                if(this.combinedFilters[i].key == 'search_in'){
                                    this.singlePicklistMapper['search_in'] = this.combinedFilters[i].default_value;
                                    if(this.$refs['search_in'] && this.$refs['search_in'][0])this.$refs['search_in'][0].value = this.combinedFilters[i].default_value;
                                }
                                if(this.combinedFilters[i].key == 'search_as'){
                                    this.singlePicklistMapper['search_as'] = this.combinedFilters[i].default_value;
                                    if(this.$refs['search_as'] && this.$refs['search_as'][0])this.$refs['search_as'][0].value = this.combinedFilters[i].default_value;
                                } 
                            }

                        })
                    }).catch((error) => {
                        console.error("Error in getting filters list", error);
                    });
                }
            if(this.appliedValues){
                this.valuesToBePopulated = this.appliedValues;
            }else{
                this.valuesToBePopulated = this.$route.query;
            }
            let query = Object.assign({}, this.valuesToBePopulated)
            if(query && 'advanceFilter' in this.valuesToBePopulated && this.valuesToBePopulated){
                let tempAdvanceFilter  = Object.keys(JSON.parse(query.advanceFilter));
                if((this.searchContext !== 'query-builder-in-reports' && tempAdvanceFilter.includes('search_as')) || Object.keys(query).includes("keyword") && query.keyword.trim().length && tempAdvanceFilter.includes('search_as')){
                    let indexA = this.findWithFilterList.findIndex(e => e.key == JSON.parse(query.advanceFilter)['search_as']);
                    if(indexA > -1)this.selectedFindWithValue = this.findWithFilterList[indexA]
                }else if(!this.checkIfNotAdvancedSearch && this.$parent && this.$parent.$refs && this.$parent.$refs.query_keyword && this.$parent.$refs.query_keyword.value && this.$parent.$refs.query_keyword.value.trim().length && tempAdvanceFilter.includes('search_as')){
                    let indexA = this.findWithFilterList.findIndex(e => e.key == JSON.parse(query.advanceFilter)['search_as']);
                    if(indexA > -1)this.selectedFindWithValue = this.findWithFilterList[indexA]
                }else{
                    this.selectedFindWithValue = {"label":"Any word","key":"any"}
                }
                this.routeQuery = JSON.parse(query.advanceFilter);
            }


        },
        isEnabled(priv){
            return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(),priv)
        },
        reloadAdvanceSearchFilters(fromReloadPanel){
            if(this.routeQuery.fields)this.routeQuery.fields = JSON.parse(JSON.stringify(this.routeQuery.fields));
            this.selectedFiltersList = []
            if(![undefined,null].includes(this.routeQuery) && Object.keys(this.routeQuery).length > 0){
                this.integerMapper = {};
                this.completeFormData.fields = {}
                let loadedList = [];
                for(let op of this.filtersList){
                    let entrySelected = false;
                    if(!loadedList.includes(op.key)){
                        loadedList.push(op.key)
                    }else{
                        //duplicated key i.e already fetched this key details
                        continue
                    }

                    if(op.filter_type == "field" && 'fields' in this.routeQuery &&
                         ![undefined,null].includes(this.routeQuery.fields) &&
                          op._id in this.routeQuery.fields &&
                          ![undefined,null].includes(this.routeQuery.fields[op._id])
                          && Object.keys(this.routeQuery.fields)){
                        entrySelected = true;
                        let fOpVal = this.routeQuery.fields[op._id]
                        if(op.type == "INTEGER"){
                            this.integerMapper[op._id] = fOpVal;
                        }else if(op.type == "PICKLIST"){
                            let valOp = op.values.filter(e=>e.value_id == fOpVal)
                            if(valOp.length > 0){
                                this.singlePicklistMapper[op._id] = valOp[0]
                            }
                            this.completeFormData.fields[op._id] = fOpVal;
                        }else if(op.type == "PICKLIST_MULTIVALUE"){
                            let array = [];
                            for(let i =0; i< fOpVal.length; i++){
                                let index = op.values.findIndex(e=>e.value_id == fOpVal[i]);
                                if(index > -1){
                                    array.push(op.values[index])
                                }
                            }
                            this.multiPicklistMapper[op._id] = array;
                        }else if(["DATE"].includes(op.type)){
                            this.dateMappper[op._id] = [fOpVal.from_value, fOpVal.to_value]
                        }else if(["DATE_TIME"].includes(op.type)){
                            let fVal = fOpVal.from_value;
                            fVal = fVal.replace("T"," ")
                            let tVal = fOpVal.to_value;
                            tVal = tVal.replace("T"," ")
                            this.dateMappper[op._id] = [fVal, tVal]
                        }
                        this.completeFormData.fields[op._id] = fOpVal;
                    }else if(op.filter_type == "metadata"){
                        if(op.key in this.routeQuery
                                && ![undefined,null].includes(this.routeQuery[op.key]) && this.routeQuery[op.key].length){
                            entrySelected = true;
                            if(['catalog_id','tag_id'].includes(op.key)){
                                let tOpVal = JSON.parse(this.routeQuery[op.key]);
                                if(op.key == 'tag_id'){
                                    this.updatedTagsList = tOpVal;
                                }else{
                                    this.updatedFilteredCatalogsList = tOpVal;
                                }
                                this.completeFormData[op.key] = this.routeQuery[op.key];
                            }else if(['slug_name', "description"].includes(op.key)){
                                this.completeFormData[op.key] = this.routeQuery[op.key];
                            }
                        }else{
                            if(op.key == 'tag_id'){
                                this.updatedTagsList = [];
                            }else if(op.key == 'catalog_id'){
                                this.updatedFilteredCatalogsList = [];
                            }
                        }
                    }else if(op.filter_type == "default" && op.key in this.routeQuery
                                && ![undefined,null].includes(this.routeQuery[op.key])){
                        entrySelected = true;
                        let fOpVal = this.routeQuery[op.key];
                        if(op.type == "PICKLIST"){
                            if(op.key && ['created_on'].includes(op.key)){
                                if(this.routeQuery[op.key]){
                                    let indexC = op.values.findIndex(e => e.value_id == this.routeQuery[op.key].type);
                                    this.selectedCreatedDateValue = op.values[indexC];
                                    if(this.routeQuery[op.key].from_value && this.routeQuery[op.key].to_value && this.selectedCreatedDateValue.value_id == 'range'){
                                        this.createdDateCustomFilterVal = [this.routeQuery[op.key].from_value, this.routeQuery[op.key].to_value];
                                    }else if(this.routeQuery[op.key].from_value && this.routeQuery[op.key].to_value && this.selectedCreatedDateValue.value_id == 'year_range'){
                                        this.createdDateCustomFilterValForYearRange = [this.routeQuery[op.key].from_value, this.routeQuery[op.key].to_value];
                                    }
                                    else{
                                        for(let cType of ["to_value","value","from_value"]){
                                            if(cType in this.routeQuery[op.key]){
                                                this.createdDateCustomFilterValSingleVal = this.routeQuery[op.key][cType];
                                                break;
                                            }
                                        }
                                    }
                                }else{
                                    this.selectedCreatedDateValue = {};
                                }
                            }else if(op.key == 'duration'){      
                                if(fOpVal && Object.keys(fOpVal).length>0 && fOpVal.type != 'range'){
                                    let optionObj = op.values.find(e=>e.value_id == fOpVal.type);
                                    this.appliedLabel = optionObj.value;
                                }else if(fOpVal && Object.keys(fOpVal).length>0 && fOpVal.type == 'range'){
                                    this.min = fOpVal.from_value ? fOpVal.from_value: "";
                                    this.max = fOpVal.to_value?fOpVal.to_value:"";
                                    this.unit = fOpVal.unit;

                                    const hasMin = this.min !== '';
                                    const hasMax = this.max !== '';

                                    if (!hasMin && !hasMax) {
                                        this.appliedLabel = '';
                                        delete this.completeFormData['duration'];
                                        alert(this.$t('Please enter either minimum Duration or maximum Duration'));
                                        return;
                                    }

                                    if (hasMin && hasMax && Number(this.max) < Number(this.min)) {
                                        this.appliedLabel = '';
                                        delete this.completeFormData['duration'];
                                        alert(this.$t('From value cannot be greater than To value'));
                                        return;
                                    }

                                    const minLabel = hasMin ? `${this.min} ${this.unit}` : `0 ${this.unit}`;
                                    const maxLabel = hasMax ? `${this.max} ${this.unit}` : this.$t('onwards');

                                    this.appliedLabel = `${minLabel} – ${maxLabel}`;

                                }
                            }else if(op.key == 'size'){      
                                if(fOpVal && Object.keys(fOpVal).length>0 && fOpVal.type != 'range'){
                                    let optionObj = op.values.find(e=>e.value_id == fOpVal.type);
                                    this.appliedSizeLabel = optionObj.value;
                                }else if(fOpVal && Object.keys(fOpVal).length>0 && fOpVal.type == 'range'){
                                    this.sizeMin = fOpVal.from_value ? fOpVal.from_value : "";
                                    this.sizeMax = fOpVal.to_value ? fOpVal.to_value : "";
                                    this.sizeUnit = fOpVal.unit;

                                    const hasMin = this.sizeMin !== '';
                                    const hasMax = this.sizeMax !== '';

                                    if (!hasMin && !hasMax) {
                                        this.appliedSizeLabel = '';
                                        alert(this.$t('Please enter either minimum size or maximum size'));
                                        return;
                                    }

                                    if (hasMin && hasMax && Number(this.sizeMax) < Number(this.sizeMin)) {
                                        this.appliedSizeLabel = '';
                                        alert(this.$t('From value cannot be greater than To value'));
                                        return;
                                    }

                                    const minLabel = hasMin ? `${this.sizeMin} ${this.sizeUnit}` : `0 ${this.sizeUnit}`;
                                    const maxLabel = hasMax ? `${this.sizeMax} ${this.sizeUnit}` : this.$t("Onwards");

                                    this.appliedSizeLabel = `${minLabel} – ${maxLabel}`;
                                }
                            }else{
                                if(op.key == 'search_in'){
                                    fOpVal = JSON.parse(fOpVal);
                                    let valOp = op.values.filter(e=>e.value_id == fOpVal[0])
                                    if(valOp.length > 0){
                                        this.singlePicklistMapper[op.key] = valOp[0]
                                    }
                                    this.completeFormData[op.key] = JSON.stringify(fOpVal);
                                }else{
                                    let valOp = op.values.filter(e=>e.value_id == fOpVal)
                                    if(valOp.length > 0){
                                        this.singlePicklistMapper[op.key] = valOp[0]
                                    }
                                }
                            }
                        }else if(op.type == "PICKLIST_MULTIVALUE"){
                            if(op.key == 'label_id'){
                                this.updatedLabelsList = JSON.parse(fOpVal);
                            }else{
                                let array = [];
                                let parsedValue = JSON.parse(fOpVal);
                                for(let i =0; i< parsedValue.length; i++){
                                    let index = op.values.findIndex(e=>e.value_id == parsedValue[i]);
                                    if(index > -1){
                                        array.push(op.values[index])
                                    }
                                }
                                this.multiPicklistMapper[op.key] = array;
                            }
                        }else if(["DATE"].includes(op.type)){
                            this.dateMappper[op.key] = [fOpVal.from_value, fOpVal.to_value]
                        }else if(["DATE_TIME"].includes(op.type)){
                            let fVal = fOpVal.from_value;
                            fVal = fVal.replace("T"," ")
                            let tVal = fOpVal.to_value;
                            tVal = tVal.replace("T"," ")
                            this.dateMappper[op.key] = [fVal, tVal]
                        }else if(op.type == 'PICKLIST' && op.key == 'catalog_id'){
                            this.selectedCatalogPIcklist = this.routeQuery['catalog_path_info'];
                        }else if(op.type == 'users'){
                            this.usersFilterMapper[op.key] = JSON.parse(fOpVal);
                        }else if(['updated_on'].includes(op.key)){
                            this.dateMappper[op.key] = [fOpVal.from_value, fOpVal.to_value];
                        }
                        if(op.key != 'search_in'){
                            this.completeFormData[op.key] = fOpVal;
                        }
                    }
                    if(entrySelected){
                        let selOp = Object.assign({},op);
                        selOp["checked"] = true;
                        if(fromReloadPanel){
                            let checkIndex = this.combinedFilters.findIndex(e => e.key == selOp.key);
                            if(checkIndex > -1){
                                this.selectedFiltersList.push(selOp);
                            }else{
                                this.removeSelectedFilter(selOp)
                            }
                        }else{
                            this.selectedFiltersList.push(selOp);
                        }
                    }
                }
                let filter = this.userFilters.concat(this.globalFilters)
                for(let op of filter){
                    if(op.key && ['created_on'].includes(op.key)){
                        if(this.routeQuery[op.key]){
                            let indexC = op.values.findIndex(e => e.value_id == this.routeQuery[op.key].type);
                            this.selectedCreatedDateValue = op.values[indexC];
                            // if(this.routeQuery[op.key].value){
                            //     this.createdDateCustomFilterValSingleVal = this.routeQuery[op.key].value;
                            // }
                            // else
                            if(this.routeQuery[op.key].from_value && this.routeQuery[op.key].to_value && this.selectedCreatedDateValue.value_id == 'range'){
                                this.createdDateCustomFilterVal = [this.routeQuery[op.key].from_value, this.routeQuery[op.key].to_value];
                            }else if(this.routeQuery[op.key].from_value && this.routeQuery[op.key].to_value && this.selectedCreatedDateValue.value_id == 'year_range'){
                                this.createdDateCustomFilterValForYearRange = [this.routeQuery[op.key].from_value, this.routeQuery[op.key].to_value];
                            }
                            else{
                                for(let cType of ["to_value","value","from_value"]){
                                    if(cType in this.routeQuery[op.key]){
                                        this.createdDateCustomFilterValSingleVal = this.routeQuery[op.key][cType];
                                        break;
                                    }
                                }
                            }
                            // else if(this.routeQuery[op.key].from_value){
                            //     this.createdDateCustomFilterValSingleVal = this.routeQuery[op.key].from_value;
                            // }
                        }else{
                            this.selectedCreatedDateValue = {};
                        }
                    }
                    if(op.filter_type == "field" && 'fields' in this.routeQuery && ![undefined,null].includes(this.routeQuery.fields) && op._id in this.routeQuery.fields && ![undefined,null].includes(this.routeQuery.fields[op._id]) && Object.keys(this.routeQuery.fields)){
                        let fOpVal = this.routeQuery.fields[op._id]
                        if(op.type == "INTEGER"){
                            this.integerMapper[op._id] = fOpVal;
                        }else if(op.type == "PICKLIST"){
                            let valOp = op.values.filter(e=>e.value_id == fOpVal)
                            if(valOp.length > 0){
                                this.singlePicklistMapper[op._id] = valOp[0]
                            }
                            this.completeFormData.fields[op._id] = fOpVal;
                        }else if(op.type == "PICKLIST_MULTIVALUE"){
                            let array = [];
                            for(let i =0; i< fOpVal.length; i++){
                                let index = op.values.findIndex(e=>e.value_id == fOpVal[i]);
                                if(index > -1){
                                    array.push(op.values[index])
                                }
                            }
                            this.multiPicklistMapper[op._id] = array;
                        }else if(["DATE"].includes(op.type)){
                            this.dateMappper[op._id] = [fOpVal.from_value, fOpVal.to_value]
                        }else if(["DATE_TIME"].includes(op.type)){
                            let fVal = fOpVal.from_value;
                            fVal = fVal.replace("T"," ")
                            let tVal = fOpVal.to_value;
                            tVal = tVal.replace("T"," ")
                            this.dateMappper[op._id] = [fVal, tVal]
                        }
                        this.completeFormData.fields[op._id] = fOpVal;
                    }else if(op.filter_type == "metadata"){
                        if(op.key in this.routeQuery
                                && ![undefined,null].includes(this.routeQuery[op.key]) && this.routeQuery[op.key].length){
                            if(['catalog_id','tag_id'].includes(op.key)){
                                let tOpVal = JSON.parse(this.routeQuery[op.key]);
                                if(op.key == 'tag_id'){
                                    this.updatedTagsList = tOpVal;
                                }else{
                                    this.updatedFilteredCatalogsList = tOpVal;
                                }
                                this.completeFormData[op.key] = this.routeQuery[op.key];
                            }else if(['slug_name', "description"].includes(op.key)){
                                this.completeFormData[op.key] = this.routeQuery[op.key];
                            }
                        }else{
                            if(op.key == 'tag_id'){
                                this.updatedTagsList = [];
                            }else if(op.key == 'catalog_id'){
                                this.updatedFilteredCatalogsList = [];
                            }
                        }
                    }else if(op.filter_type == "default" && op.key in this.routeQuery
                                && ![undefined,null].includes(this.routeQuery[op.key])){
                        let fOpVal = this.routeQuery[op.key]
                        if(op.type == "INTEGER"){
                            this.integerMapper[op.key] = fOpVal;
                        }else if(op.type == "PICKLIST"){
                            if(op.type == 'PICKLIST' && op.key == 'catalog_id'){
                                this.selectedCatalogPIcklist = this.routeQuery['catalog_path_info'];
                            }else{
                                if(op.key == 'search_in'){
                                    fOpVal = JSON.parse(fOpVal);
                                    let valOp = op.values.filter(e=>e.value_id == fOpVal[0])
                                    if(valOp.length > 0){
                                        this.singlePicklistMapper[op.key] = valOp[0]
                                    }   
                                }else if(op.key == 'duration'){      
                                    if(fOpVal && Object.keys(fOpVal).length>0 && fOpVal.type != 'range'){
                                        let optionObj = op.values.find(e=>e.value_id == fOpVal.type);
                                        this.appliedLabel = optionObj.value;
                                    }else if(fOpVal && Object.keys(fOpVal).length>0 && fOpVal.type == 'range'){
                                        this.min = fOpVal.from_value ? fOpVal.from_value : "";
                                        this.max = fOpVal.to_value ? fOpVal.to_value : "";
                                        this.unit = fOpVal.unit;

                                        const hasMin = this.min !== '';
                                        const hasMax = this.max !== '';

                                        if (!hasMin && !hasMax) {
                                            this.appliedLabel = '';
                                            delete this.completeFormData['duration'];
                                            alert(this.$t('Please enter either minimum Duration or maximum Duration'));
                                            return;
                                        }

                                        if (hasMin && hasMax && Number(this.max) < Number(this.min)) {
                                            this.appliedLabel = '';
                                            delete this.completeFormData['duration'];
                                            alert(this.$t('From value cannot be greater than To value'));
                                            return;
                                        }

                                        const minLabel = hasMin ? `${this.min} ${this.unit}` : `0 ${this.unit}`;
                                        const maxLabel = hasMax ? `${this.max} ${this.unit}` : this.$t('onwards');

                                        this.appliedLabel = `${minLabel} – ${maxLabel}`;
                                    }
                                }else if(op.key == 'size'){      
                                    if(fOpVal && Object.keys(fOpVal).length>0 && fOpVal.type != 'range'){
                                        let optionObj = op.values.find(e=>e.value_id == fOpVal.type);
                                        this.appliedSizeLabel = optionObj.value;
                                    }else if(fOpVal && Object.keys(fOpVal).length>0 && fOpVal.type == 'range'){
                                        this.sizeMin = fOpVal.from_value ? fOpVal.from_value : "";
                                        this.sizeMax = fOpVal.from_value ? fOpVal.to_value : "";
                                        this.sizeUnit = fOpVal.unit;

                                        const hasMin = this.sizeMin !== '';
                                        const hasMax = this.sizeMax !== '';

                                        if (!hasMin && !hasMax) {
                                            this.appliedSizeLabel = '';
                                            alert(this.$t('Please enter either minimum size or maximum size'));
                                            return;
                                        }

                                        if (hasMin && hasMax && Number(this.sizeMax) < Number(this.sizeMin)) {
                                            this.appliedSizeLabel = '';
                                            alert(this.$t('From value cannot be greater than To value'));
                                            return;
                                        }

                                        const minLabel = hasMin ? `${this.sizeMin} ${this.sizeUnit}` : `0 ${this.sizeUnit}`;
                                        const maxLabel = hasMax ? `${this.sizeMax} ${this.sizeUnit}` : this.$t("Onwards");

                                        this.appliedSizeLabel = `${minLabel} – ${maxLabel}`;
                                    }
                                }else{
                                    let valOp = op.values.filter(e=>e.value_id == fOpVal)
                                    if(valOp.length > 0){
                                        this.singlePicklistMapper[op.key] = valOp[0]
                                    }   
                                }   
                            }
                        if(op.key == 'search_in'){
                            this.completeFormData[op.key] = JSON.stringify(fOpVal);
                        }else{
                            this.completeFormData[op.key] = fOpVal;
                        }
                        }else if(op.type == "PICKLIST_MULTIVALUE"){
                            if(op.key == 'label_id'){
                                this.updatedLabelsList = JSON.parse(fOpVal);
                            }else{
                                let array = [];
                                let parsedValue = JSON.parse(fOpVal);
                                for(let i =0; i< parsedValue.length; i++){
                                    let index = op.values.findIndex(e=>e.value_id == parsedValue[i]);
                                    if(index > -1){
                                        array.push(op.values[index])
                                    }
                                }
                                this.multiPicklistMapper[op.key] = array;
                            }
                            this.completeFormData[op.key] = fOpVal;
                        }else if(["DATE"].includes(op.type)){
                            this.dateMappper[op.key] = [fOpVal.from_value, fOpVal.to_value]
                        }else if(["DATE_TIME"].includes(op.type)){
                            let fVal = fOpVal.from_value;
                            fVal = fVal.replace("T"," ")
                            let tVal = fOpVal.to_value;
                            tVal = tVal.replace("T"," ")
                            this.dateMappper[op.key] = [fVal, tVal]
                        }else if(op.type == 'users'){
                            this.usersFilterMapper[op.key] = JSON.parse(fOpVal);
                        }else if(['created_on','updated_on'].includes(op.key)){
                            this.dateMappper[op.key] = [fOpVal.from_value, fOpVal.to_value];
                        }
                        if(op.key != 'search_in'){
                            this.completeFormData[op.key] = fOpVal;
                        }
                    }
                }
            }
        },
        ...mapActions("search", ["getConfiguredSearchActionsFromServer",'updateUserFilters','updateGlobalFilters']),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapGetters("users",["getLoggedInUserType",'getLoggedInUserId','getLoggedInUserPrivilege']),
        ...mapMutations("startUpData",["updatestartupDatainfo"]),
        ...mapGetters("search", ["getAdvancedSearchDataFromStore"]),
        ...mapGetters("queryBuilder", ["getQueryBuiderTypes", "getQueryBuiderQueryParamters", "getColumnsRequiredInQueryBuilderReport"]),
        ...mapMutations("search",["setAdvancedSearchState","setAdvancedSearchDataToStore"]),
    },
    watch: {
        appliedValues(newVal){
            if(newVal)this.valuesToBePopulated = newVal;
            this.reloadRouteFilters();
            this.getfiltersListOnContext();
        },
        'searchContext': function (val) {
            if(val){
                this.getfiltersListOnContext();
            }
        },
        globalFilters(){
            let aiFilters = this.globalFilters.find(op=>op.key == 'ai_plugin');
            if(aiFilters){
                this.findInFilterList = this.findInFilterList.concat(aiFilters.values);
                this.reloadRouteFilters();
            }
        },
        isNLPSearchMode(newVal){
            this.enableDisableSearchWithFilter(newVal);
         }
        
    },
    mounted(){
       setTimeout(() => {
        this.show = true;
        }, 200);
    },
    created(){
        this.$options.components['CatalogDropdown'] = CatalogDropdown
        this.registerforWebsocketNotifications()
        this.reloadRouteFilters();
        this.getfiltersListOnContext();

    },
    beforeDestroy(){
        this.unRegisterforWebsocketNotifications()
    }
}
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:22px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $applied-filter-background: #1c6c8e;
    $applied-filter-text-color: #eee;
    $add-button-border-color:#b7b228;
    
    @mixin common-filter-header-styles{
        padding: 10px 10px !important;
        color: $add-button-border-color;
        border: unset;
        background: unset !important;
        font-size:14px;
    }

    .focusTheField{
        outline: none;
        bottom: 0px;
        inset-inline-start:0px;
        --saf-0: rgba(var(--sk_highlight,18,100,163),1);
        box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
        border-radius: 4px;
        border-color: transparent;
        -webkit-appearance: none;
    }

    .reset-button{
        display: flex;
        align-items: center;
        margin-inline-start: 6px;
        color: $secondary-text-color;
        height: 30px;
        padding: 7px;
        svg{
            fill: $secondary-text-color;
        }
    }
    .reset-button:hover{
        background: $tags-background-color;
        color: $text-color;
        border-radius: 6px;
        svg{
            fill: $text-color
        }
    }
    .advanced-search-wrapper{
        height:auto;
        display: flex;
        flex-direction: column;
        .add-search-filter{
            width:auto;
            color: $active-blue;
            height: 35px !important;
            margin-top: 0px !important;
            svg{
                color:$active-blue;
            }
        }
        .selected-filters-wrapper{
            list-style-type: none;
            display: inline-flex;
            flex-wrap: wrap;
            padding: 0px;
            width: 99.8%;
            justify-content: start;
            overflow: auto;
            align-items: center;
            .selected-filter{
                margin: 4px 0px;
                margin-inline-start: 5px;
                height: fit-content
            }
        }
    }
    .selected-filter{
        margin: 4px 0px;
        margin-inline-start: 10px;
    }

    .apply-background{
        .dropdown-header{
            padding-inline-end:0px !important;
        }    
    }
    textarea:focus{
        outline: none;
        bottom: 0px;
        inset-inline-start:0px;
        --saf-0: rgba(var(--sk_highlight,18,100,163),1);
        box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
        border-radius: 4px;
        border-color: transparent;
        -webkit-appearance: none;
    }
    .comm-input-field-style{
        background: $primary-background !important;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        height: $input-field-height;
    }
    .empty-field-text-styles{
        color:$none-text-color;
    }

    .input-field-wrapper{
        display: inline-flex;
        width: 100%;
        position: relative;
        svg{
        position: absolute;
        inset-inline-end: -27px;
        top: 12px;
        height:25px;
        }
    }

    .fields-on-non-edit-mode{
    width:100%;
    display:inline-flex;
    line-height:46px;
    }

    .bigger-checkboxes {
        height: 30px;
        width: 20px;
        position:relative;
    }
    input[type="checkbox"]:after {
        line-height: 1.5em;
        content: "";
        display: inline-block !important;
        width: 22px !important;
        height: 21px !important;
        margin-top: 5px !important;
        margin-inline-start: -1px !important;
        border: $border-color !important;
        border-radius: 0.25em !important;
        background: $primary-background !important;
    }
    input[type="checkbox"]:checked:after {
        content: "✔";
        color: $active-blue !important;
        position: absolute !important;
        font-size: 16px !important;
        line-height: 1 !important;
        transition: all 0.2s !important;
        font-family: Helvetica, Arial, sans-serif;
        padding-inline-start: 4px !important;
        padding-top: 2px !important;
    }

    .user-name-or-image{
        height: 30px;
        width: 30px;
        border: $border-color;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        margin-top: 3px;
    }

    .tags-display-ul{
    list-style-type: none;
    }

    .tags-display-ul .show-tags-delete{
    visibility:hidden;
    }

    .searched-metadata-display-fields{
    height: auto;
    width: 90%;
    }

    .view-tags:hover .show-tags-delete{
    visibility: visible;
    }

    .view-tags:hover {
        border: $border-color !important;
    }

    .key-style {
    color: $dull-text-color;
    width: 30%;
    text-align: center;
    font-size: $input-field-and-label-font-size;
    padding-inline-start: 5px;
    padding-inline-end: 5px;
    margin-top: 13px;
    }

    .activeTag{
        color: $active-blue !important;
    }
    .view-tags{
        font-size: 12px;
        height: 24px;
        display: inline-flex;
        margin:2px !important;
        border: $border-color !important;
        border-radius: 15px !important;
        min-width: 50px;
        padding: 0px !important;
        text-align: center;
        width:auto !important;
        padding-inline-start: 12px !important;
        justify-content: center;
        padding-top: 1px !important;
        div{
                padding: 0px 8px;
                margin-inline-start: 0px;
                font-size: 12px;
                border-radius: 15px !important;
                position: relative;
                top: 1px;
        }
    }

    .view-fields-styles{
        font-size: 12px;
        height: 24px;
        display: inline-flex;
        margin:2px !important;
        border-radius: 15px !important;
        min-width: 50px;
        padding: 0px !important;
        text-align: start;
        width:98% !important;
        padding-inline-start: 12px !important;
        justify-content: start;
        padding-top: 1px !important;
        div{
                padding: 0px 8px;
                margin-inline-start: 0px;
                font-size: 14px;
                line-height: 32px;
                color: $secondary-text-color;
                text-align:end;
        }
    }

    .comm-tags-field-wrapper-style{
        background: $primary-background!important;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        min-height: $input-field-height;
        margin-top:1px;
        margin-bottom:1px;
        border-radius: 4px;
    }

    .comm-input-field-style:focus{
        outline:none !important;
        box-shadow: none !important;
    }
    ::v-deep{
        .mx-datepicker-popup{
            z-index:99999 !important;
        }
    .theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
        background: $primary-background;
        border-bottom: $border-color;
    }
    .mx-input{
        background-color: $primary-background  !important;
        border: none !important;
        color: $text-color !important;
    }
    .mx-datepicker-main{
        border: $border-color !important;
        background: $secondary-background-color !important;
        z-index: 9999 !important;
    }
    .mx-calendar-content .cell:hover{
        background-color: $bg-color-on-hover !important;
    }
    .mx-datepicker-range{
        width:auto;
    }
    .mx-calendar-content .cell:hover {
        color: #000000;
        background-color: #7d99b1;
    }
    .mx-icon-calendar{
        color:$text-color;
    }
    .mx-input:focus{
        outline:none !important;
        box-shadow: none !important;
    }
    }

    .value-style{
    width: 98%;
    text-align: start;
    padding-top: 0px;
    padding-bottom: 3px;
    padding-inline-end: 5px;
    .slug-ellipsis{
        white-space: nowrap;
        max-width: 350px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    }
    .input-fields{
        border: none;
        border-radius: 0px !important;
        // margin-inline-start:5px;
        // margin-bottom: 7px;
    }

    .focusField{
        input:focus, select:focus{
        border:none !important;
    }
    }

    .tags-wrapper{
    position: absolute;
    inset-inline-end: 0px;
    }

    svg {
    color: #666666;
    }

    svg:hover {
    color: $text-color;
    }

    .table-scroll {
    /*width:100%; */
    border: none !important;
    /* Decoration */
    border-spacing: 0;
    width: 100%;
    thead {
        color: $dull-text-color !important;
        position: relative;
        th{
        position: sticky;
        top: 0;
        background: $primary-background;
        z-index:9;
        text-align: start;
        padding:0px;
        border:none;
        }
    }
    tbody {
        width: 100%;
        overflow: auto;
        font-weight: 500;
        tr{
        height:40px;
        border-bottom: 1px solid $primary-background;
        padding:0px;
        }
    }
    }


    .delete-btn {
        visibility: hidden;
    }
    .comm-table-row:hover .delete-btn {
        visibility: visible;
        position: relative;
        inset-inline-start:8px;
        vertical-align: top;
    }

    /* width */
    ::-webkit-scrollbar {
    width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
    }

    .height-set-for-component {
    height: calc(100% - 120px);
    }

    .comm-custom-range-fields{
        .dropdown {
            position: relative;
        }

        .dropdown-header {
            // background: #333;
            // border: 1px solid #444;
            border-radius: 4px;
            padding: 6px 14px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color:#fff;
        }

        .selected-value-div{
            color:#fff;
        }
        // .dropdown-header.active {
        //     border-color: #5f6cff;
        //     background: #1e2050;
        // }

        .arrow {
            border: solid #aaa;
            border-width: 0 2px 2px 0;
            padding: 3px;
            transform: rotate(45deg);
        }

        .dropdown-list {
            position: fixed;
            width: 250px;
            text-align: start;
            background: #15181B !important;
            // border: 1px solid #444;
            border-radius: 4px;
            margin-top: 4px;
            z-index: 100;
        }

        .option {
            padding: 12px 16px;
            cursor: pointer;
            color:#eee;
        }

        .option:hover {
            background: #22272b;
        }

        .custom-row {
            padding: 12px 16px;
            border-top: 1px solid #444;
            cursor: pointer;
            color:#eee;
        }

        .custom-row:hover {
            background: #22272b;
        }

        .inputs {
            display: flex;
            gap: 8px;
            padding: 10px 16px;
            background: #15171b;
        }

        input, select {
            width: 100%;
            padding: 7px;
            background: #15171b;
            border: 1px solid #444;
            border-radius: 4px;
            color: #fff;
        }

        input:focus, select:focus {
            border-color: $active-blue;
            outline: none;
        }

        .actions {
            display: flex;
            justify-content: flex-end;
            gap: 10px;
            padding: 10px 16px 14px;
            background: #15171b;
            border-top: 1px solid #3a3a3a;
        }

        .btn {
            padding: 6px 14px;
            border-radius: 4px;
            font-size: 13px;
            cursor: pointer;
        }

        .btn.cancel {
            background: transparent;
            color: #6c757d;
            border: 1px solid #6c757d;
        }

        .btn.apply {
            background: $active-blue;
            color: #fff;
            border: none;
        }

        .clear-x {
            margin-inline-start: 10px;
            cursor: pointer;
            color: #999;
        }

        .clear-x:hover {
            color: #fff;
        }
    }

    ::v-deep{

    .apply-background{
        .mx-input-wrapper{
            display: flex;
            justify-content: flex-start;
            padding-inline-start: 12px;
            background: $applied-filter-background !important;
            color: $applied-filter-text-color !important;
        }
        .mx-datepicker-range{
            .mx-input-wrapper{
                padding-inline-start: 0px;
            }
        }
    }

    .catalog-filter{
        .multiselect{
            height:unset;
            min-height:30px;
            width:100% !important;
            .multiselect__single {
                padding-top: 3px !important;
                margin-bottom: 6px;
                top:5px !important;
            }
        }
    }
    .apply-background{
        background: $applied-filter-background !important;
        color: $applied-filter-text-color !important;
        border: 1px solid #229ed2 !important;
        .comm-input-field-style,.selected-tags-style, .multiselect__input, .tags-style{
            background: #156382 !important;
            color: $applied-filter-text-color !important;
        }
        .selected-tags-style, .tags-style{
            border: 1px solid #343434 !important;
        }
        .multiselect__tags, .mx-input{
            background: $applied-filter-background !important;
        }
        .multiselect__single, .mx-input, .mx-icon-calendar, .mx-icon-clear, button, svg{
            color: $applied-filter-text-color !important;
        }
        .remove-tag{
            svg{
                color: $applied-filter-text-color !important;
            }
        }
        .multiselect__select::before{
            border-color: #b8b8b8 transparent transparent !important;
        }
        .multiselect__placeholder, ::placeholder {
            color: #d7d7d7 !important;
        }
        svg{
            fill: #bababa
        }
    }
    
    .apply-background:hover{
        svg{
            fill: #eee;
        }
    }
    .multiselect__select{
        height: 30px;
    }

    // .multiselect__select::before{
    //     top:54%;
    // }
    .multi-tags-select, .single-selection{
        .multiselect__select::before{
            top:65%;
        }
    }

    ::placeholder {
        color: #5d5d5d  !important;
    }

    .add-search-filter{
        display: inline-flex;
        border: 3px solid $border-color-only !important;
        .add-fileds-icon{
            position: absolute;
            inset-inline-start:10px;
            z-index: 99;
            top: 13px;
        }
        .multiselect{
            min-width:15%;
            margin: -2px 0px;
            .multiselect__tag{
                display:none;
            }
            .multiselect__select{
                display:none;
            }
        }
    }

    .config-add-filter{
        background:transparent !important;
        border: 2px solid #21698f !important;
        color: #2d8fc3 !important;
        svg{
            color: #2d8fc3 !important;
        }
        .multiselect__tags{
            background:transparent !important;
        }
    }

    .config-add-filter:hover{
        color:#eee !important;
        border: 2px solid #21698f !important;
        svg{
            fill:#eee;
        }
        .multiselect__tags{
            background:transparent !important;
        }
    }
    
    .multiselect{
            width:100%;
            margin: 3px 0px;
    }
    .multiselect__content-wrapper{
        display:none;
    }
    .multiselect__tag, .tags-style {
        background-color: $primary-background !important;
        border: $border-color;
        border-radius: 5px;
        margin-bottom:0px;
    }
    .multiselect__tags, .tags-style {
        background: $primary-background !important;
        border: $border-color !important;
    }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
            color:$secondary-text-color !important;
            font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__tags{
            padding: 1px 40px 0 8px !important;
            display: flex;
            flex-direction: column;
            justify-content: center; 
        }
        .multiselect__placeholder {
            margin-bottom:0px;
            color:#5d5d5d !important;    
            padding-top:0px !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 30px;
        }
        .multiselect__single{
            padding-top:3px !important;
            margin-bottom: 6px;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: fixed !important;
            display: block;
            background: $text-color;
            width: 18% !important;
            max-height: 200px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background !important;
            height: auto !important;
            min-height: 30px !important;
        }
        .add-search-filter{
            .multiselect{
                min-height: 25px !important;
            }
            .multiselect__tags {
                min-height: 26px !important;
            }
        }
        .filter-wrapper{
            display:inline-flex;
            align-items: center;
            border: $border-color;
            border-radius: 5px;
            background: $primary-background ;
            color:$dull-text-color;
            margin-inline-end:6px;
            min-height:35px;
            margin-bottom:5px;
            .filter-label{
                margin:0px 4px;
                width: auto;
                white-space: nowrap;
                padding-inline-start:4px;
            }
            .comm-input-field-style,.multiselect__tags{
                border: none !important;
                border-radius: none !important;
            }
            .mx-input{
                height:22px;
            }
            .multiselect{
                margin:0px !important;
            }
        }
    }

    .browse-icon{
        position: relative;
        inset-inline-start:18px;
        top: 3px;
    }

    .table td, .table th {
        border-top: none;
        padding:0px;
    }

    .display-as-tags{
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: start;
        float: inline-start;
    }

    .select-catalog-field{
        width: 101%;
        .value-style{
        width:100%;
        }
    }

    .editIconClass{
    visibility: hidden;
    }

    .comm-screen-profile-fields:hover{
    .editIconClass{
        visibility: visible;
        margin-inline-start: 8px;
    }
    }

    .user-name-or-image-in-selected-option{
    border: $border-color;
    height: 27px;
    width: 27px;
    border-radius: 5px;
    text-align: center;
    line-height: 26px;
    text-transform: uppercase;
    margin-top: -1px;
    margin-inline-start: -1px;
    }

    .tags-style{
        display: inline-flex;
        margin-inline-end: 5px;
        margin-bottom: 5px;
        height: 27px;
        margin-inline-start: 3px;
        float:inline-start;
    .user-name-display-as-tags{
        line-height: 27px;
        margin: 0px 5px;
        width:auto;
    }
    }

    .comm-field-wrapper{
        padding:5px;
        vertical-align: top;
    }

    .select-action-styles{
        margin-inline-end:10px;
        position: relative;
        top: 5px;
        width: 35% !important;
    }

    .primary-btn-style{
        margin-top:1%;
        height:70px;
        display:inline-flex !important;
        flex-wrap: nowrap !important;
        margin-inline-start:4px;
        button{
            height: 37px !important;
            border-radius: 5px;
            width: 100px;
            font-size:14px;
        }
    }
    .action-select-dropdown{
        width: 36% !important;
        margin-inline-end: 9px;
    }

    .selected-tags-style{
        background: $bg-color-on-hover;
        border: 1px solid #363636;
        border-radius: 15px;
        font-size: 12px !important;
        min-height: 25px !important;
        display: inline-flex !important;
        margin: 2px !important;
        border-radius: 15px !important;
        min-width: 50px !important;
        padding: 0px !important;
        text-align: center;
        width: auto !important;
        padding-inline-start: 12px !important;
        justify-content: center;
        padding-top: 2px !important;
        padding-inline-end: 4px !important;
        .remove-tag{
            line-height:18px;
            color: #858585;
        }
        }


        .configure-dropdown{
            display: flex;
            background: rgb(238, 238, 238);
            overflow: auto;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            border: 1px solid rgb(34, 39, 43) !important;
            width: 18% !important;
            flex-direction: column;
            position: fixed !important;
            top:100px;
            inset-inline-end:unset;
            inset-inline-start:unset;
        }

        .dropdown-menu{
            background-color:$secondary-background-color !important;
            border: $border-color;
            .dropdown-item{
                color:$text-color;
                font-size:14px !important; 
                display:flex;
                align-items:center;
            }
        }
      
        .dropdown-item:hover{
            background-color:$bg-color-on-hover !important;
        }

        .shortcut-actions-type-icons-wrapper{
            color: #999;
            background: #15181b!important;
            height: 30px;
            align-items: center;
            min-width: 130px;
            width: auto;
            border-bottom-right-radius: 4px;
            border-top-left-radius: 4px;
            position: absolute;
            line-height: 1;
            margin-inline-start: 8px;
            border: 1px solid #4a4a4a;
            display: flex;
            padding: 8px;
            border-radius: 0.375em;
            top: 15px;
            inset-inline-start:11px;
            svg{
                margin-inline-start: 6px;
                margin-inline-end: 6px;
            }
        }

        .shortcut-actions-type-icons-wrapper svg:hover{
            fill: #fdfff4;
        }
        .shortcut-actions-type-icons-wrapper:hover{
            color: #fdfff4 !important;
        }
        .shortcut-actions-type-icons-wrapper .copy-link-action{
            color: #a3adad !important;
        }

        .dropdown-toggle{
            color: $secondary-text-color;
        }
        
        .dropdown-toggle:hover{
            svg{
                fill: $text-color;
            }
        }

        .config-filters{
            height:34px !important;
            color: #d7d7d7;
            border: 1px solid #21698f;
            background: #0c2734 !important;
            svg{
                fill: $secondary-text-color;
            }
        }

        .configure-global-filters, .configure-local-filters{
            border: 1px solid #3a3a3a;
            padding: 0px 5px;
        }

        .global-filters{
            background: #000c195e !important;
            border: 1px solid #21698f !important;
        }

        .user-filter{
            background: #2d200982 !important;
            border: 1px solid #21698f !important;
        }

        .global-filter-tag{
            @include common-filter-header-styles;
            .filter-wrapper{
                background:transparent;
            }
        }

        .user-filter-tag{
            @include common-filter-header-styles;
            .filter-wrapper{
                background:transparent;
            }
        }

        .notAdminType{
            opacity: 0.8;
            background: #0c263d00 !important;
            color: #7c7c7c;
        }

        .remove-field-styles{
            margin-inline-end:2px;
        }

        .remove-field-styles:hover{
            background: #4d52564d;
            color: $text-color !important;
            border-radius: 6px;
            svg{
                fill: $text-color !important;
            }
        }

</style>